export const vehicle_makes_and_models = {
  results: [
    {
      make: {
        value: 'ACURA',
        label: 'Acura',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
      ],
    },
    {
      make: {
        value: 'ALFA',
        label: 'Alfa Romeo',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ALFA164',
          label: '164',
        },
        {
          value: 'ALFA4C',
          label: '4C',
        },
        {
          value: 'ALFA8C',
          label: '8C Competizione',
        },
        {
          value: 'ALFAGIULIA',
          label: 'Giulia',
        },
        {
          value: 'ALFAGT',
          label: 'GTV-6',
        },
        {
          value: 'MIL',
          label: 'Milano',
        },
        {
          value: 'ALFAOTH',
          label: 'Other Alfa Romeo Models',
        },
        {
          value: 'SPID',
          label: 'Spider',
        },
        {
          value: 'ALFASTELV',
          label: 'Stelvio',
        },
        {
          value: 'ALFATONALE',
          label: 'Tonale',
        },
      ],
    },
    {
      make: {
        value: 'AMC',
        label: 'AMC',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'AMCALLIAN',
          label: 'Alliance',
        },
        {
          value: 'CON',
          label: 'Concord',
        },
        {
          value: 'EAGLE',
          label: 'Eagle',
        },
        {
          value: 'AMCENC',
          label: 'Encore',
        },
        {
          value: 'AMCOTH',
          label: 'Other AMC Models',
        },
        {
          value: 'AMCSPIRIT',
          label: 'Spirit',
        },
      ],
    },
    {
      make: {
        value: 'ASTON',
        label: 'Aston Martin',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ASTONDB11',
          label: 'DB11',
        },
        {
          value: 'ASTONDB12',
          label: 'DB12',
        },
        {
          value: 'DB7',
          label: 'DB7',
        },
        {
          value: 'DB9',
          label: 'DB9',
        },
        {
          value: 'DBS',
          label: 'DBS',
        },
        {
          value: 'ASTONDBX',
          label: 'DBX',
        },
        {
          value: 'LAGONDA',
          label: 'Lagonda',
        },
        {
          value: 'ASTOTH',
          label: 'Other Aston Martin Models',
        },
        {
          value: 'RAPIDE',
          label: 'Rapide',
        },
        {
          value: 'ASTRAPIDES',
          label: 'Rapide S',
        },
        {
          value: 'V12VANT',
          label: 'V12 Vantage',
        },
        {
          value: 'VANTAGE',
          label: 'V8 Vantage',
        },
        {
          value: 'VANQUISH',
          label: 'Vanquish',
        },
        {
          value: 'VIRAGE',
          label: 'Virage',
        },
      ],
    },
    {
      make: {
        value: 'AUDI',
        label: 'Audi',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'AUDI100',
          label: '100',
        },
        {
          value: 'AUDI200',
          label: '200',
        },
        {
          value: '4000',
          label: '4000',
        },
        {
          value: '5000',
          label: '5000',
        },
        {
          value: '80',
          label: '80',
        },
        {
          value: '90',
          label: '90',
        },
        {
          value: 'A3',
          label: 'A3',
        },
        {
          value: 'A4',
          label: 'A4',
        },
        {
          value: 'A5',
          label: 'A5',
        },
        {
          value: 'A6',
          label: 'A6',
        },
        {
          value: 'A7',
          label: 'A7',
        },
        {
          value: 'A8',
          label: 'A8',
        },
        {
          value: 'ALLRDQUA',
          label: 'allroad',
        },
        {
          value: 'AUDICABRI',
          label: 'Cabriolet',
        },
        {
          value: 'AUDICOUPE',
          label: 'Coupe',
        },
        {
          value: 'AUDIETRON',
          label: 'e-tron',
        },
        {
          value: 'AUDETRONGT',
          label: 'e-tron GT',
        },
        {
          value: 'AUDIETRONS',
          label: 'e-tron S',
        },
        {
          value: 'AUDOTH',
          label: 'Other Audi Models',
        },
        {
          value: 'Q3',
          label: 'Q3',
        },
        {
          value: 'AUDQ4ETRN',
          label: 'Q4 e-tron',
        },
        {
          value: 'Q5',
          label: 'Q5',
        },
        {
          value: 'Q7',
          label: 'Q7',
        },
        {
          value: 'AUDIQ8',
          label: 'Q8',
        },
        {
          value: 'AUDIQ8ETRN',
          label: 'Q8 e-tron',
        },
        {
          value: 'QUATTR',
          label: 'Quattro',
        },
        {
          value: 'R8',
          label: 'R8',
        },
        {
          value: 'AUDIRS3',
          label: 'RS 3',
        },
        {
          value: 'RS4',
          label: 'RS 4',
        },
        {
          value: 'RS5',
          label: 'RS 5',
        },
        {
          value: 'RS6',
          label: 'RS 6',
        },
        {
          value: 'AUDIRS7',
          label: 'RS 7',
        },
        {
          value: 'AUDRSETRON',
          label: 'RS e-tron GT',
        },
        {
          value: 'AUDIRSQ8',
          label: 'RS Q8',
        },
        {
          value: 'AUDS3',
          label: 'S3',
        },
        {
          value: 'S4',
          label: 'S4',
        },
        {
          value: 'S5',
          label: 'S5',
        },
        {
          value: 'S6',
          label: 'S6',
        },
        {
          value: 'S7',
          label: 'S7',
        },
        {
          value: 'S8',
          label: 'S8',
        },
        {
          value: 'AUDISQ5',
          label: 'SQ5',
        },
        {
          value: 'AUDISQ7',
          label: 'SQ7',
        },
        {
          value: 'AUDISQ8',
          label: 'SQ8',
        },
        {
          value: 'AUDSQ8ETRN',
          label: 'SQ8 e-tron',
        },
        {
          value: 'TT',
          label: 'TT',
        },
        {
          value: 'TTRS',
          label: 'TT RS',
        },
        {
          value: 'TTS',
          label: 'TTS',
        },
        {
          value: 'V8',
          label: 'V8 Quattro',
        },
      ],
    },
    {
      make: {
        value: 'BENTL',
        label: 'Bentley',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ARNAGE',
          label: 'Arnage',
        },
        {
          value: 'AZURE',
          label: 'Azure',
        },
        {
          value: 'BENBENTAY',
          label: 'Bentayga',
        },
        {
          value: 'BROOKLANDS',
          label: 'Brooklands',
        },
        {
          value: 'BENCONT',
          label: 'Continental',
        },
        {
          value: 'BENEIGHT',
          label: 'Eight',
        },
        {
          value: 'BENFLYSPUR',
          label: 'Flying Spur',
        },
        {
          value: 'BENMUL',
          label: 'Mulsanne',
        },
        {
          value: 'BENOTH',
          label: 'Other Bentley Models',
        },
        {
          value: 'BENTURBO',
          label: 'Turbo R',
        },
      ],
    },
    {
      make: {
        value: 'BMW',
        label: 'BMW',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: '1_SERIES',
          label: '1 Series',
        },
        {
          value: '135IS',
          label: ' - 135is',
        },
        {
          value: '128I',
          label: ' - 128i',
        },
        {
          value: '135I',
          label: ' - 135i',
        },
        {
          value: '2_SERIES',
          label: '2 Series',
        },
        {
          value: 'BMW228IXD',
          label: ' - 228i xDrive',
        },
        {
          value: 'BMW228I',
          label: ' - 228i',
        },
        {
          value: 'BMWM235I',
          label: ' - M235i',
        },
        {
          value: 'BMWM240I',
          label: ' - M240i',
        },
        {
          value: 'BMWM240IXD',
          label: ' - M240i xDrive',
        },
        {
          value: 'BMW230I',
          label: ' - 230i',
        },
        {
          value: 'BMW230IXD',
          label: ' - 230i xDrive',
        },
        {
          value: 'BMWM235IXD',
          label: ' - M235i xDrive',
        },
        {
          value: 'BMW228XDGC',
          label: ' - 228i xDrive Gran Coupe',
        },
        {
          value: 'BMWM235GC',
          label: ' - M235i xDrive Gran Coupe',
        },
        {
          value: 'BMW228IGC',
          label: ' - 228i Gran Coupe',
        },
        {
          value: '3_SERIES',
          label: '3 Series',
        },
        {
          value: '323I',
          label: ' - 323i',
        },
        {
          value: 'BMW325',
          label: ' - 325',
        },
        {
          value: '325IX',
          label: ' - 325iX',
        },
        {
          value: '325XI',
          label: ' - 325xi',
        },
        {
          value: 'BMW328D',
          label: ' - 328d',
        },
        {
          value: 'BMW328DXD',
          label: ' - 328d xDrive',
        },
        {
          value: 'BMW328GTXD',
          label: ' - 328i Gran Turismo xDrive',
        },
        {
          value: 'BMW335GTXD',
          label: ' - 335i Gran Turismo xDrive',
        },
        {
          value: '320I',
          label: ' - 320i',
        },
        {
          value: '323IS',
          label: ' - 323is',
        },
        {
          value: '335I',
          label: ' - 335i',
        },
        {
          value: '330CI',
          label: ' - 330Ci',
        },
        {
          value: '330I',
          label: ' - 330i',
        },
        {
          value: '330XI',
          label: ' - 330xi',
        },
        {
          value: 'ACTIVE3',
          label: ' - ActiveHybrid 3',
        },
        {
          value: '318I',
          label: ' - 318i',
        },
        {
          value: '318IS',
          label: ' - 318iS',
        },
        {
          value: '318TI',
          label: ' - 318ti',
        },
        {
          value: '328CI',
          label: ' - 328Ci',
        },
        {
          value: '328I',
          label: ' - 328i',
        },
        {
          value: '328IS',
          label: ' - 328iS',
        },
        {
          value: '325CI',
          label: ' - 325Ci',
        },
        {
          value: '325E',
          label: ' - 325e',
        },
        {
          value: '325I',
          label: ' - 325i',
        },
        {
          value: '325IS',
          label: ' - 325is',
        },
        {
          value: '328XI',
          label: ' - 328xi',
        },
        {
          value: '323CI',
          label: ' - 323ci',
        },
        {
          value: '335D',
          label: ' - 335d',
        },
        {
          value: 'BMW330E',
          label: ' - 330e',
        },
        {
          value: 'BMW330XDGT',
          label: ' - 330i Gran Turismo xDrive',
        },
        {
          value: 'BMW340XDGT',
          label: ' - 340i Gran Turismo xDrive',
        },
        {
          value: '325ES',
          label: ' - 325es',
        },
        {
          value: '335XI',
          label: ' - 335xi',
        },
        {
          value: '335IS',
          label: ' - 335is',
        },
        {
          value: 'BMW340IXD',
          label: ' - 340i xDrive',
        },
        {
          value: 'BMW340I',
          label: ' - 340i',
        },
        {
          value: '320IXD',
          label: ' - 320i xDrive',
        },
        {
          value: 'BMW330IXD',
          label: ' - 330i xDrive',
        },
        {
          value: '328IXD',
          label: ' - 328i xDrive',
        },
        {
          value: '335IXD',
          label: ' - 335i xDrive',
        },
        {
          value: 'BMW330EXD',
          label: ' - 330e xDrive',
        },
        {
          value: 'BMWM340IXD',
          label: ' - M340i xDrive',
        },
        {
          value: 'BMWM340I',
          label: ' - M340i',
        },
        {
          value: '4_SERIES',
          label: '4 Series',
        },
        {
          value: 'BMW440GC',
          label: ' - 440i Gran Coupe',
        },
        {
          value: 'BMW440GCXD',
          label: ' - 440i Gran Coupe xDrive',
        },
        {
          value: 'BMW428I',
          label: ' - 428i',
        },
        {
          value: 'BMW435I',
          label: ' - 435i',
        },
        {
          value: 'BMW428IXD',
          label: ' - 428i xDrive',
        },
        {
          value: 'BMW435IXD',
          label: ' - 435i xDrive',
        },
        {
          value: 'BMW428GC',
          label: ' - 428i Gran Coupe',
        },
        {
          value: 'BMW428GCXD',
          label: ' - 428i Gran Coupe xDrive',
        },
        {
          value: 'BMW435GC',
          label: ' - 435i Gran Coupe',
        },
        {
          value: 'BMW435GCXD',
          label: ' - 435i Gran Coupe xDrive',
        },
        {
          value: 'BMW430I',
          label: ' - 430i',
        },
        {
          value: 'BMW430IXD',
          label: ' - 430i xDrive',
        },
        {
          value: 'BMW430GC',
          label: ' - 430i Gran Coupe',
        },
        {
          value: 'BMW430GCXD',
          label: ' - 430i Gran Coupe xDrive',
        },
        {
          value: 'BMW440I',
          label: ' - 440i',
        },
        {
          value: 'BMW440IXD',
          label: ' - 440i xDrive',
        },
        {
          value: 'BMWM440XGC',
          label: ' - M440i xDrive Gran Coupe',
        },
        {
          value: 'BMWM440IXD',
          label: ' - M440i xDrive',
        },
        {
          value: 'BMWM440I',
          label: ' - M440i',
        },
        {
          value: 'BMWM440IGC',
          label: ' - M440i Gran Coupe',
        },
        {
          value: '5_SERIES',
          label: '5 Series',
        },
        {
          value: 'BMW530IXD',
          label: ' - 530i xDrive',
        },
        {
          value: 'ACTIVE5',
          label: ' - ActiveHybrid 5',
        },
        {
          value: '524TD',
          label: ' - 524td',
        },
        {
          value: '545I',
          label: ' - 545i',
        },
        {
          value: 'BMW535D',
          label: ' - 535d',
        },
        {
          value: 'BMW535DXD',
          label: ' - 535d xDrive',
        },
        {
          value: '530XI',
          label: ' - 530xi',
        },
        {
          value: '525XI',
          label: ' - 525xi',
        },
        {
          value: '550I',
          label: ' - 550i',
        },
        {
          value: '525I',
          label: ' - 525i',
        },
        {
          value: '528E',
          label: ' - 528e',
        },
        {
          value: '528I',
          label: ' - 528i',
        },
        {
          value: '530I',
          label: ' - 530i',
        },
        {
          value: '533I',
          label: ' - 533i',
        },
        {
          value: '535I',
          label: ' - 535i',
        },
        {
          value: '540I',
          label: ' - 540i',
        },
        {
          value: 'BMW530EXD',
          label: ' - 530e xDrive',
        },
        {
          value: 'BMWM550IXD',
          label: ' - M550i xDrive',
        },
        {
          value: 'BMW530E',
          label: ' - 530e',
        },
        {
          value: 'BMW540DXD',
          label: ' - 540d xDrive',
        },
        {
          value: '535XI',
          label: ' - 535xi',
        },
        {
          value: '528XI',
          label: ' - 528xi',
        },
        {
          value: '550IGT',
          label: ' - 550i Gran Turismo',
        },
        {
          value: 'BMW540IXD',
          label: ' - 540i xDrive',
        },
        {
          value: '535IGT',
          label: ' - 535i Gran Turismo',
        },
        {
          value: '528IXD',
          label: ' - 528i xDrive',
        },
        {
          value: '535IXD',
          label: ' - 535i xDrive',
        },
        {
          value: '535IGTXD',
          label: ' - 535i Gran Turismo xDrive',
        },
        {
          value: '550IGTXD',
          label: ' - 550i Gran Turismo xDrive',
        },
        {
          value: '550IXD',
          label: ' - 550i xDrive',
        },
        {
          value: '6_SERIES',
          label: '6 Series',
        },
        {
          value: '645CI',
          label: ' - 645Ci',
        },
        {
          value: 'BMW640IXD',
          label: ' - 640i xDrive',
        },
        {
          value: 'BMW640GCXD',
          label: ' - 640i Gran Coupe xDrive',
        },
        {
          value: 'BMWB6XDGC',
          label: ' - ALPINA B6 xDrive Gran Coupe',
        },
        {
          value: '650IGC',
          label: ' - 650i Gran Coupe',
        },
        {
          value: 'L6',
          label: ' - L6',
        },
        {
          value: '633CSI',
          label: ' - 633CSi',
        },
        {
          value: '635CSI',
          label: ' - 635CSi',
        },
        {
          value: '650I',
          label: ' - 650i',
        },
        {
          value: '640I',
          label: ' - 640i',
        },
        {
          value: '640IGC',
          label: ' - 640i Gran Coupe',
        },
        {
          value: 'BMW640GTXD',
          label: ' - 640i Gran Turismo xDrive',
        },
        {
          value: '650IXD',
          label: ' - 650i xDrive',
        },
        {
          value: '650IGCXD',
          label: ' - 650i Gran Coupe xDrive',
        },
        {
          value: '7_SERIES',
          label: '7 Series',
        },
        {
          value: 'BMW740LDXD',
          label: ' - 740Ld xDrive',
        },
        {
          value: 'L7',
          label: ' - L7',
        },
        {
          value: '745LI',
          label: ' - 745Li',
        },
        {
          value: '760LI',
          label: ' - 760Li',
        },
        {
          value: '760I',
          label: ' - 760i',
        },
        {
          value: '750I',
          label: ' - 750i',
        },
        {
          value: '750LI',
          label: ' - 750Li',
        },
        {
          value: '733I',
          label: ' - 733i',
        },
        {
          value: '735I',
          label: ' - 735i',
        },
        {
          value: '735IL',
          label: ' - 735iL',
        },
        {
          value: '740I',
          label: ' - 740i',
        },
        {
          value: '740IL',
          label: ' - 740iL',
        },
        {
          value: '745I',
          label: ' - 745i',
        },
        {
          value: '750IL',
          label: ' - 750iL',
        },
        {
          value: 'BMW740IXD',
          label: ' - 740i xDrive',
        },
        {
          value: '740LI',
          label: ' - 740Li',
        },
        {
          value: 'BMW740EXD',
          label: ' - 740e xDrive',
        },
        {
          value: 'BMWM760IXD',
          label: ' - M760i xDrive',
        },
        {
          value: 'ALPINAB7',
          label: ' - ALPINA B7',
        },
        {
          value: 'ACTIVE7',
          label: ' - ActiveHybrid 7',
        },
        {
          value: '740LIXD',
          label: ' - 740Li xDrive',
        },
        {
          value: '750IXD',
          label: ' - 750i xDrive',
        },
        {
          value: '750LIXD',
          label: ' - 750Li xDrive',
        },
        {
          value: 'ALPINAB7XD',
          label: ' - ALPINA B7 xDrive',
        },
        {
          value: 'BMW750EXD',
          label: ' - 750e xDrive',
        },
        {
          value: 'BMW760IXD',
          label: ' - 760i xDrive',
        },
        {
          value: 'BMW745EXD',
          label: ' - 745e xDrive',
        },
        {
          value: '8_SERIES',
          label: '8 Series',
        },
        {
          value: '840CI',
          label: ' - 840Ci',
        },
        {
          value: '850CI',
          label: ' - 850Ci',
        },
        {
          value: '850CSI',
          label: ' - 850CSi',
        },
        {
          value: '850I',
          label: ' - 850i',
        },
        {
          value: 'BMWALPB8GC',
          label: ' - ALPINA B8 xDrive Gran Coupe',
        },
        {
          value: 'BMW850IXD',
          label: ' - M850i xDrive',
        },
        {
          value: 'BMW840I',
          label: ' - 840i',
        },
        {
          value: 'BMW840IXD',
          label: ' - 840i xDrive',
        },
        {
          value: 'BMWM850GCX',
          label: ' - M850i Gran Coupe xDrive',
        },
        {
          value: 'BMW840GC',
          label: ' - 840i Gran Coupe',
        },
        {
          value: 'BMW840GCXD',
          label: ' - 840i Gran Coupe xDrive',
        },
        {
          value: 'M3_SERIES',
          label: 'M3 Series',
        },
        {
          value: 'M3',
          label: ' - M3',
        },
        {
          value: 'BMWM3XD',
          label: ' - M3 xDrive',
        },
        {
          value: 'M4_SERIES',
          label: 'M4 Series',
        },
        {
          value: 'BMWM4',
          label: ' - M4',
        },
        {
          value: 'BMWM4XD',
          label: ' - M4 xDrive',
        },
        {
          value: '1SERIESM',
          label: '1 Series M',
        },
        {
          value: 'ACTIVEX6',
          label: 'ActiveHybrid X6',
        },
        {
          value: 'BMWALPXB7',
          label: 'ALPINA XB7',
        },
        {
          value: 'BMWI3',
          label: 'i3',
        },
        {
          value: 'BMWI4',
          label: 'i4',
        },
        {
          value: 'BMWI5',
          label: 'i5',
        },
        {
          value: 'BMWI7',
          label: 'i7',
        },
        {
          value: 'BMWI8',
          label: 'i8',
        },
        {
          value: 'BMWIX',
          label: 'iX',
        },
        {
          value: 'BMWMCOUPE',
          label: 'M Coupe',
        },
        {
          value: 'BMWROAD',
          label: 'M Roadster',
        },
        {
          value: 'BMWM2',
          label: 'M2',
        },
        {
          value: 'M5',
          label: 'M5',
        },
        {
          value: 'M6',
          label: 'M6',
        },
        {
          value: 'BMWM6GC',
          label: 'M6 Gran Coupe',
        },
        {
          value: 'BMWM8',
          label: 'M8',
        },
        {
          value: 'BMWM8GCXD',
          label: 'M8 Gran Coupe xDrive',
        },
        {
          value: 'BMWOTH',
          label: 'Other BMW Models',
        },
        {
          value: 'X1',
          label: 'X1',
        },
        {
          value: 'BMWX2',
          label: 'X2',
        },
        {
          value: 'X3',
          label: 'X3',
        },
        {
          value: 'BMWX3M',
          label: 'X3 M',
        },
        {
          value: 'BMWX4',
          label: 'X4',
        },
        {
          value: 'BMWX4M',
          label: 'X4 M',
        },
        {
          value: 'X5',
          label: 'X5',
        },
        {
          value: 'X5M',
          label: 'X5 M',
        },
        {
          value: 'X6',
          label: 'X6',
        },
        {
          value: 'X6M',
          label: 'X6 M',
        },
        {
          value: 'BMWX7',
          label: 'X7',
        },
        {
          value: 'BMWXM',
          label: 'XM',
        },
        {
          value: 'Z3',
          label: 'Z3',
        },
        {
          value: 'Z4',
          label: 'Z4',
        },
        {
          value: 'Z8',
          label: 'Z8',
        },
      ],
    },
    {
      make: {
        value: 'BUGATTI',
        label: 'Bugatti',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'BUGCHIRON',
          label: 'Chiron',
        },
        {
          value: 'BUGDIVO',
          label: 'Divo',
        },
        {
          value: 'BUGVEY',
          label: 'Veyron',
        },
      ],
    },
    {
      make: {
        value: 'BUICK',
        label: 'Buick',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'BUICASCADA',
          label: 'Cascada',
        },
        {
          value: 'CENT',
          label: 'Century',
        },
        {
          value: 'ELEC',
          label: 'Electra',
        },
        {
          value: 'ENCLAVE',
          label: 'Enclave',
        },
        {
          value: 'BUIENC',
          label: 'Encore',
        },
        {
          value: 'BUIENCGX',
          label: 'Encore GX',
        },
        {
          value: 'BUIENVISI',
          label: 'Envision',
        },
        {
          value: 'BUIENVISTA',
          label: 'Envista',
        },
        {
          value: 'LACROSSE',
          label: 'LaCrosse',
        },
        {
          value: 'LESA',
          label: 'Le Sabre',
        },
        {
          value: 'LUCERNE',
          label: 'Lucerne',
        },
        {
          value: 'BUOTH',
          label: 'Other Buick Models',
        },
        {
          value: 'PARK',
          label: 'Park Avenue',
        },
        {
          value: 'RAINIER',
          label: 'Rainier',
        },
        {
          value: 'REATTA',
          label: 'Reatta',
        },
        {
          value: 'REG',
          label: 'Regal',
        },
        {
          value: 'RENDEZVOUS',
          label: 'Rendezvous',
        },
        {
          value: 'RIV',
          label: 'Riviera',
        },
        {
          value: 'BUICKROAD',
          label: 'Roadmaster',
        },
        {
          value: 'SKYH',
          label: 'Skyhawk',
        },
        {
          value: 'SKYL',
          label: 'Skylark',
        },
        {
          value: 'SOMER',
          label: 'Somerset',
        },
        {
          value: 'TERRAZA',
          label: 'Terraza',
        },
        {
          value: 'BUVERANO',
          label: 'Verano',
        },
      ],
    },
    {
      make: {
        value: 'CAD',
        label: 'Cadillac',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ALLANT',
          label: 'Allante',
        },
        {
          value: 'ATS',
          label: 'ATS',
        },
        {
          value: 'BROUGH',
          label: 'Brougham',
        },
        {
          value: 'CATERA',
          label: 'Catera',
        },
        {
          value: 'CIMA',
          label: 'Cimarron',
        },
        {
          value: 'CADCT4',
          label: 'CT4',
        },
        {
          value: 'CADCT5',
          label: 'CT5',
        },
        {
          value: 'CADCT6',
          label: 'CT6',
        },
        {
          value: 'CTS',
          label: 'CTS',
        },
        {
          value: 'DEV',
          label: 'De Ville',
        },
        {
          value: 'DTS',
          label: 'DTS',
        },
        {
          value: 'ELDO',
          label: 'Eldorado',
        },
        {
          value: 'CADELR',
          label: 'ELR',
        },
        {
          value: 'ESCALA',
          label: 'Escalade',
        },
        {
          value: 'ESCALAESV',
          label: 'Escalade ESV',
        },
        {
          value: 'EXT',
          label: 'Escalade EXT',
        },
        {
          value: 'FLEE',
          label: 'Fleetwood',
        },
        {
          value: 'CADLYRIQ',
          label: 'Lyriq',
        },
        {
          value: 'CADOTH',
          label: 'Other Cadillac Models',
        },
        {
          value: 'SEV',
          label: 'Seville',
        },
        {
          value: 'SRX',
          label: 'SRX',
        },
        {
          value: 'STS',
          label: 'STS',
        },
        {
          value: 'XLR',
          label: 'XLR',
        },
        {
          value: 'CADXT4',
          label: 'XT4',
        },
        {
          value: 'CADXT5',
          label: 'XT5',
        },
        {
          value: 'CADXT6',
          label: 'XT6',
        },
        {
          value: 'XTS',
          label: 'XTS',
        },
      ],
    },
    {
      make: {
        value: 'CHEV',
        label: 'Chevrolet',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ASTRO',
          label: 'Astro',
        },
        {
          value: 'AVALNCH',
          label: 'Avalanche',
        },
        {
          value: 'AVEO',
          label: 'Aveo',
        },
        {
          value: 'AVEO5',
          label: 'Aveo5',
        },
        {
          value: 'BERETT',
          label: 'Beretta',
        },
        {
          value: 'BLAZER',
          label: 'Blazer',
        },
        {
          value: 'CHEBOLT',
          label: 'Bolt',
        },
        {
          value: 'CHEBOLTEUV',
          label: 'Bolt EUV',
        },
        {
          value: 'CHEVCK',
          label: 'C/K Truck',
        },
        {
          value: 'CAM',
          label: 'Camaro',
        },
        {
          value: 'CAP',
          label: 'Caprice',
        },
        {
          value: 'CHECAPS',
          label: 'Captiva Sport',
        },
        {
          value: 'CAV',
          label: 'Cavalier',
        },
        {
          value: 'CELE',
          label: 'Celebrity',
        },
        {
          value: 'CHEVETTE',
          label: 'Chevette',
        },
        {
          value: 'CITATION',
          label: 'Citation',
        },
        {
          value: 'CHECITYEXP',
          label: 'City Express',
        },
        {
          value: 'COBALT',
          label: 'Cobalt',
        },
        {
          value: 'COLORADO',
          label: 'Colorado',
        },
        {
          value: 'CORSI',
          label: 'Corsica',
        },
        {
          value: 'CORV',
          label: 'Corvette',
        },
        {
          value: 'CRUZE',
          label: 'Cruze',
        },
        {
          value: 'ELCAM',
          label: 'El Camino',
        },
        {
          value: 'EQUINOX',
          label: 'Equinox',
        },
        {
          value: 'CHEXP1500',
          label: 'Express 1500',
        },
        {
          value: 'CHEXP2500',
          label: 'Express 2500',
        },
        {
          value: 'CHEXP3500',
          label: 'Express 3500',
        },
        {
          value: 'CHEXP4500',
          label: 'Express 4500',
        },
        {
          value: 'CHEG10',
          label: 'G10',
        },
        {
          value: 'CHEG20',
          label: 'G20',
        },
        {
          value: 'CHEG30',
          label: 'G30',
        },
        {
          value: 'HHR',
          label: 'HHR',
        },
        {
          value: 'CHEVIMP',
          label: 'Impala',
        },
        {
          value: 'KODC4500',
          label: 'Kodiak C4500',
        },
        {
          value: 'LUMINA',
          label: 'Lumina',
        },
        {
          value: 'LAPV',
          label: 'Lumina APV',
        },
        {
          value: 'LUV',
          label: 'LUV',
        },
        {
          value: 'MALI',
          label: 'Malibu',
        },
        {
          value: 'CHVMETR',
          label: 'Metro',
        },
        {
          value: 'CHEVMONT',
          label: 'Monte Carlo',
        },
        {
          value: 'NOVA',
          label: 'Nova',
        },
        {
          value: 'CHEOTH',
          label: 'Other Chevrolet Models',
        },
        {
          value: 'CHEVPRIZM',
          label: 'Prizm',
        },
        {
          value: 'CHVST',
          label: 'S10 Blazer',
        },
        {
          value: 'S10PICKUP',
          label: 'S10 Pickup',
        },
        {
          value: 'CHEV150',
          label: 'Silverado 1500',
        },
        {
          value: 'CHEVC25',
          label: 'Silverado 2500',
        },
        {
          value: 'CH3500PU',
          label: 'Silverado 3500',
        },
        {
          value: 'SONIC',
          label: 'Sonic',
        },
        {
          value: 'SPARK',
          label: 'Spark',
        },
        {
          value: 'CHEVSPEC',
          label: 'Spectrum',
        },
        {
          value: 'CHSPRINT',
          label: 'Sprint',
        },
        {
          value: 'CHEVSS',
          label: 'SS',
        },
        {
          value: 'SSR',
          label: 'SSR',
        },
        {
          value: 'CHEVSUB',
          label: 'Suburban',
        },
        {
          value: 'TAHOE',
          label: 'Tahoe',
        },
        {
          value: 'TRACKE',
          label: 'Tracker',
        },
        {
          value: 'TRAILBLZ',
          label: 'TrailBlazer',
        },
        {
          value: 'TRAILBZEXT',
          label: 'TrailBlazer EXT',
        },
        {
          value: 'TRAVERSE',
          label: 'Traverse',
        },
        {
          value: 'CHETRAX',
          label: 'Trax',
        },
        {
          value: 'UPLANDER',
          label: 'Uplander',
        },
        {
          value: 'VENTUR',
          label: 'Venture',
        },
        {
          value: 'VOLT',
          label: 'Volt',
        },
      ],
    },
    {
      make: {
        value: 'CHRY',
        label: 'Chrysler',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'CHRYS200',
          label: '200',
        },
        {
          value: '300',
          label: '300',
        },
        {
          value: 'CHRY300',
          label: '300M',
        },
        {
          value: 'ASPEN',
          label: 'Aspen',
        },
        {
          value: 'CIRRUS',
          label: 'Cirrus',
        },
        {
          value: 'CONC',
          label: 'Concorde',
        },
        {
          value: 'CHRYCONQ',
          label: 'Conquest',
        },
        {
          value: 'CORDOBA',
          label: 'Cordoba',
        },
        {
          value: 'CROSSFIRE',
          label: 'Crossfire',
        },
        {
          value: 'ECLASS',
          label: 'E Class',
        },
        {
          value: 'FIFTH',
          label: 'Fifth Avenue',
        },
        {
          value: 'CHRYGRANDV',
          label: 'Grand Voyager',
        },
        {
          value: 'IMPE',
          label: 'Imperial',
        },
        {
          value: 'INTREPID',
          label: 'Intrepid',
        },
        {
          value: 'CHRYLAS',
          label: 'Laser',
        },
        {
          value: 'LEBA',
          label: 'LeBaron',
        },
        {
          value: 'CHRYLEBGTS',
          label: 'LeBaron GTS',
        },
        {
          value: 'LHS',
          label: 'LHS',
        },
        {
          value: 'NY',
          label: 'New Yorker',
        },
        {
          value: 'NEWPORT',
          label: 'Newport',
        },
        {
          value: 'CHOTH',
          label: 'Other Chrysler Models',
        },
        {
          value: 'PACIFICA',
          label: 'Pacifica',
        },
        {
          value: 'CHPROWLE',
          label: 'Prowler',
        },
        {
          value: 'PTCRUIS',
          label: 'PT Cruiser',
        },
        {
          value: 'CHRYSEB',
          label: 'Sebring',
        },
        {
          value: 'CHRYTC',
          label: 'TC by Maserati',
        },
        {
          value: 'TANDC',
          label: 'Town & Country',
        },
        {
          value: 'VOYAGER',
          label: 'Voyager',
        },
      ],
    },
    {
      make: {
        value: 'DAEW',
        label: 'Daewoo',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'LANOS',
          label: 'Lanos',
        },
        {
          value: 'LEGANZA',
          label: 'Leganza',
        },
        {
          value: 'NUBIRA',
          label: 'Nubira',
        },
        {
          value: 'DAEOTH',
          label: 'Other Daewoo Models',
        },
      ],
    },
    {
      make: {
        value: 'DATSUN',
        label: 'Datsun',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'DAT200SX',
          label: '200SX',
        },
        {
          value: 'DAT210',
          label: '210',
        },
        {
          value: '280Z',
          label: '280ZX',
        },
        {
          value: '300ZX',
          label: '300ZX',
        },
        {
          value: '310',
          label: '310',
        },
        {
          value: '510',
          label: '510',
        },
        {
          value: '720',
          label: '720',
        },
        {
          value: '810',
          label: '810',
        },
        {
          value: 'DATMAX',
          label: 'Maxima',
        },
        {
          value: 'DATOTH',
          label: 'Other Datsun Models',
        },
        {
          value: 'DATPU',
          label: 'Pickup',
        },
        {
          value: 'PUL',
          label: 'Pulsar',
        },
        {
          value: 'DATSENT',
          label: 'Sentra',
        },
        {
          value: 'STAN',
          label: 'Stanza',
        },
      ],
    },
    {
      make: {
        value: 'DELOREAN',
        label: 'DeLorean',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'DMC12',
          label: 'DMC-12',
        },
      ],
    },
    {
      make: {
        value: 'DODGE',
        label: 'Dodge',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: '400',
          label: '400',
        },
        {
          value: 'DOD600',
          label: '600',
        },
        {
          value: 'ARI',
          label: 'Aries',
        },
        {
          value: 'AVENGR',
          label: 'Avenger',
        },
        {
          value: 'B150',
          label: 'B150',
        },
        {
          value: 'B1500',
          label: 'B1500',
        },
        {
          value: 'B250',
          label: 'B250',
        },
        {
          value: 'B2500',
          label: 'B2500',
        },
        {
          value: 'B350',
          label: 'B350',
        },
        {
          value: 'B3500',
          label: 'B3500',
        },
        {
          value: 'CALIBER',
          label: 'Caliber',
        },
        {
          value: 'DODCARA',
          label: 'Caravan',
        },
        {
          value: 'CHALLENGER',
          label: 'Challenger',
        },
        {
          value: 'DODCHAR',
          label: 'Charger',
        },
        {
          value: 'DODCOLT',
          label: 'Colt',
        },
        {
          value: 'DODCONQ',
          label: 'Conquest',
        },
        {
          value: 'DODDW',
          label: 'D/W Truck',
        },
        {
          value: 'DAKOTA',
          label: 'Dakota',
        },
        {
          value: 'DODDART',
          label: 'Dart',
        },
        {
          value: 'DAY',
          label: 'Daytona',
        },
        {
          value: 'DIPLOMA',
          label: 'Diplomat',
        },
        {
          value: 'DURANG',
          label: 'Durango',
        },
        {
          value: 'DODDYNA',
          label: 'Dynasty',
        },
        {
          value: 'GRANDCARAV',
          label: 'Grand Caravan',
        },
        {
          value: 'DODHORNET',
          label: 'Hornet',
        },
        {
          value: 'INTRE',
          label: 'Intrepid',
        },
        {
          value: 'JOURNEY',
          label: 'Journey',
        },
        {
          value: 'LANCERDODG',
          label: 'Lancer',
        },
        {
          value: 'MAGNUM',
          label: 'Magnum',
        },
        {
          value: 'MIRADA',
          label: 'Mirada',
        },
        {
          value: 'MONACO',
          label: 'Monaco',
        },
        {
          value: 'DODNEON',
          label: 'Neon',
        },
        {
          value: 'NITRO',
          label: 'Nitro',
        },
        {
          value: 'OMNI',
          label: 'Omni',
        },
        {
          value: 'DOOTH',
          label: 'Other Dodge Models',
        },
        {
          value: 'RAIDER',
          label: 'Raider',
        },
        {
          value: 'RAM1504WD',
          label: 'Ram 1500 Truck',
        },
        {
          value: 'RAM25002WD',
          label: 'Ram 2500 Truck',
        },
        {
          value: 'RAM3502WD',
          label: 'Ram 3500 Truck',
        },
        {
          value: 'RAM4500',
          label: 'Ram 4500 Truck',
        },
        {
          value: 'DODD50',
          label: 'Ram 50 Truck',
        },
        {
          value: 'RAM5500',
          label: 'Ram 5500 Truck',
        },
        {
          value: 'RAMSRT10',
          label: 'Ram SRT-10',
        },
        {
          value: 'RAMCGR',
          label: 'Ramcharger',
        },
        {
          value: 'RAMPAGE',
          label: 'Rampage',
        },
        {
          value: 'DODSHAD',
          label: 'Shadow',
        },
        {
          value: 'DODSPIR',
          label: 'Spirit',
        },
        {
          value: 'SPRINTER',
          label: 'Sprinter',
        },
        {
          value: 'SRT4',
          label: 'SRT-4',
        },
        {
          value: 'STREGIS',
          label: 'St. Regis',
        },
        {
          value: 'STEAL',
          label: 'Stealth',
        },
        {
          value: 'STRATU',
          label: 'Stratus',
        },
        {
          value: 'VIPER',
          label: 'Viper',
        },
      ],
    },
    {
      make: {
        value: 'EAGLE',
        label: 'Eagle',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'EAGLEMED',
          label: 'Medallion',
        },
        {
          value: 'EAGOTH',
          label: 'Other Eagle Models',
        },
        {
          value: 'EAGLEPREM',
          label: 'Premier',
        },
        {
          value: 'SUMMIT',
          label: 'Summit',
        },
        {
          value: 'TALON',
          label: 'Talon',
        },
        {
          value: 'VISION',
          label: 'Vision',
        },
      ],
    },
    {
      make: {
        value: 'FER',
        label: 'Ferrari',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'FER296GTB',
          label: '296 GTB',
        },
        {
          value: 'FER296GTS',
          label: '296 GTS',
        },
        {
          value: '308',
          label: '308',
        },
        {
          value: '328',
          label: '328',
        },
        {
          value: '348',
          label: '348',
        },
        {
          value: '360',
          label: '360',
        },
        {
          value: '456GT',
          label: '456 GT',
        },
        {
          value: '456MGT',
          label: '456M GT',
        },
        {
          value: '458ITALIA',
          label: '458 Italia',
        },
        {
          value: 'FER458SPEC',
          label: '458 Speciale',
        },
        {
          value: 'FER458SPID',
          label: '458 Spider',
        },
        {
          value: 'FER488GTB',
          label: '488 GTB',
        },
        {
          value: 'FER488PISA',
          label: '488 Pista',
        },
        {
          value: 'FER488SPI',
          label: '488 Spider',
        },
        {
          value: '512M',
          label: '512M',
        },
        {
          value: '512TR',
          label: '512TR',
        },
        {
          value: '550M',
          label: '550 Maranello',
        },
        {
          value: '575M',
          label: '575M Maranello',
        },
        {
          value: '599GTB',
          label: '599 GTB Fiorano',
        },
        {
          value: '599GTO',
          label: '599 GTO',
        },
        {
          value: 'FERSAPERTA',
          label: '599 SA Aperta',
        },
        {
          value: '612SCAGLIE',
          label: '612 Scaglietti',
        },
        {
          value: 'FER812COMP',
          label: '812 Competizione',
        },
        {
          value: 'FER812GTS',
          label: '812 GTS',
        },
        {
          value: 'FER812SUP',
          label: '812 Superfast',
        },
        {
          value: 'FERCALIF',
          label: 'California',
        },
        {
          value: 'ENZO',
          label: 'Enzo',
        },
        {
          value: 'FERF12BERL',
          label: 'F12 Berlinetta',
        },
        {
          value: 'FERF12TDF',
          label: 'F12tdf',
        },
        {
          value: 'F355',
          label: 'F355',
        },
        {
          value: 'F40',
          label: 'F40',
        },
        {
          value: 'F430',
          label: 'F430',
        },
        {
          value: 'F50',
          label: 'F50',
        },
        {
          value: 'FERF8SPID',
          label: 'F8 Spider',
        },
        {
          value: 'FERF8TRIB',
          label: 'F8 Tributo',
        },
        {
          value: 'FERFF',
          label: 'FF',
        },
        {
          value: 'FERGTC4LUS',
          label: 'GTC4Lusso',
        },
        {
          value: 'FERLAF',
          label: 'LaFerrari',
        },
        {
          value: 'MOND',
          label: 'Mondial',
        },
        {
          value: 'FEROTH',
          label: 'Other Ferrari Models',
        },
        {
          value: 'FERPORTO',
          label: 'Portofino',
        },
        {
          value: 'FERPORTOM',
          label: 'Portofino M',
        },
        {
          value: 'FERROMA',
          label: 'Roma',
        },
        {
          value: 'FERSF90SPI',
          label: 'SF90 Spider',
        },
        {
          value: 'FERSF90STR',
          label: 'SF90 Stradale',
        },
        {
          value: 'TEST',
          label: 'Testarossa',
        },
      ],
    },
    {
      make: {
        value: 'FIAT',
        label: 'FIAT',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'FIAT124SPI',
          label: '124 Spider',
        },
        {
          value: '2000',
          label: '2000 Spider',
        },
        {
          value: 'FIAT500',
          label: '500',
        },
        {
          value: 'FIAT500L',
          label: '500L',
        },
        {
          value: 'FIAT500X',
          label: '500X',
        },
        {
          value: 'BERTON',
          label: 'Bertone X1/9',
        },
        {
          value: 'BRAVA',
          label: 'Brava',
        },
        {
          value: 'FIAOTH',
          label: 'Other Fiat Models',
        },
        {
          value: 'PININ',
          label: 'Pininfarina Spider',
        },
        {
          value: 'STRADA',
          label: 'Strada',
        },
        {
          value: 'FIATX19',
          label: 'X1/9',
        },
      ],
    },
    {
      make: {
        value: 'FISK',
        label: 'Fisker',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'KARMA',
          label: 'Karma',
        },
        {
          value: 'FISKOCEAN',
          label: 'Ocean',
        },
      ],
    },
    {
      make: {
        value: 'FORD',
        label: 'Ford',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'AERO',
          label: 'Aerostar',
        },
        {
          value: 'ASPIRE',
          label: 'Aspire',
        },
        {
          value: 'BRON',
          label: 'Bronco',
        },
        {
          value: 'B2',
          label: 'Bronco II',
        },
        {
          value: 'FORDBRONSP',
          label: 'Bronco Sport',
        },
        {
          value: 'FOCMAX',
          label: 'C-MAX',
        },
        {
          value: 'CONTOUR',
          label: 'Contour',
        },
        {
          value: 'COURIER',
          label: 'Courier',
        },
        {
          value: 'CROWNVIC',
          label: 'Crown Victoria',
        },
        {
          value: 'E100ECON',
          label: 'E-100',
        },
        {
          value: 'E150ECON',
          label: 'E-150 and Econoline 150',
        },
        {
          value: 'E250ECON',
          label: 'E-250 and Econoline 250',
        },
        {
          value: 'E350ECON',
          label: 'E-350 and Econoline 350',
        },
        {
          value: 'FORDE450',
          label: 'E-450 and Econoline 450',
        },
        {
          value: 'FORDETRAN',
          label: 'E-Transit',
        },
        {
          value: 'FORDECOSPT',
          label: 'EcoSport',
        },
        {
          value: 'EDGE',
          label: 'Edge',
        },
        {
          value: 'ESCAPE',
          label: 'Escape',
        },
        {
          value: 'ESCO',
          label: 'Escort',
        },
        {
          value: 'EXCURSION',
          label: 'Excursion',
        },
        {
          value: 'EXP',
          label: 'EXP',
        },
        {
          value: 'EXPEDI',
          label: 'Expedition',
        },
        {
          value: 'EXPEDIEL',
          label: 'Expedition EL',
        },
        {
          value: 'FORDEXPMAX',
          label: 'Expedition Max',
        },
        {
          value: 'EXPLOR',
          label: 'Explorer',
        },
        {
          value: 'SPORTTRAC',
          label: 'Explorer Sport Trac',
        },
        {
          value: 'F100',
          label: 'F100',
        },
        {
          value: 'F150PICKUP',
          label: 'F150',
        },
        {
          value: 'F250',
          label: 'F250',
        },
        {
          value: 'F350',
          label: 'F350',
        },
        {
          value: 'F450',
          label: 'F450',
        },
        {
          value: 'FORDF550',
          label: 'F550',
        },
        {
          value: 'FORDF600',
          label: 'F600',
        },
        {
          value: 'FORDF650',
          label: 'F650',
        },
        {
          value: 'FORDF750',
          label: 'F750',
        },
        {
          value: 'FAIRM',
          label: 'Fairmont',
        },
        {
          value: 'FESTIV',
          label: 'Festiva',
        },
        {
          value: 'FIESTA',
          label: 'Fiesta',
        },
        {
          value: 'FIVEHUNDRE',
          label: 'Five Hundred',
        },
        {
          value: 'FLEX',
          label: 'Flex',
        },
        {
          value: 'FOCUS',
          label: 'Focus',
        },
        {
          value: 'FREESTAR',
          label: 'Freestar',
        },
        {
          value: 'FREESTYLE',
          label: 'Freestyle',
        },
        {
          value: 'FUSION',
          label: 'Fusion',
        },
        {
          value: 'GRANADA',
          label: 'Granada',
        },
        {
          value: 'GT',
          label: 'GT',
        },
        {
          value: 'LTD',
          label: 'LTD',
        },
        {
          value: 'FORDMAVER',
          label: 'Maverick',
        },
        {
          value: 'MUST',
          label: 'Mustang',
        },
        {
          value: 'FORDMACHE',
          label: 'Mustang Mach-E',
        },
        {
          value: 'FOOTH',
          label: 'Other Ford Models',
        },
        {
          value: 'PROBE',
          label: 'Probe',
        },
        {
          value: 'RANGER',
          label: 'Ranger',
        },
        {
          value: 'TAURUS',
          label: 'Taurus',
        },
        {
          value: 'TAURUSX',
          label: 'Taurus X',
        },
        {
          value: 'TEMPO',
          label: 'Tempo',
        },
        {
          value: 'TBIRD',
          label: 'Thunderbird',
        },
        {
          value: 'FORDTRN150',
          label: 'Transit 150',
        },
        {
          value: 'FORDTRN250',
          label: 'Transit 250',
        },
        {
          value: 'FORDTRN350',
          label: 'Transit 350',
        },
        {
          value: 'TRANSCONN',
          label: 'Transit Connect',
        },
        {
          value: 'WINDST',
          label: 'Windstar',
        },
        {
          value: 'FORDZX2',
          label: 'ZX2 Escort',
        },
      ],
    },
    {
      make: {
        value: 'FREIGHT',
        label: 'Freightliner',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'FRESPRINT',
          label: 'Sprinter',
        },
      ],
    },
    {
      make: {
        value: 'GENESIS',
        label: 'Genesis',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'GENELECG80',
          label: 'Electrified G80',
        },
        {
          value: 'GENELEGV70',
          label: 'Electrified GV70',
        },
        {
          value: 'GENG70',
          label: 'G70',
        },
        {
          value: 'GENG80',
          label: 'G80',
        },
        {
          value: 'GENG90',
          label: 'G90',
        },
        {
          value: 'GENGV60',
          label: 'GV60',
        },
        {
          value: 'GENGV70',
          label: 'GV70',
        },
        {
          value: 'GENGV80',
          label: 'GV80',
        },
      ],
    },
    {
      make: {
        value: 'GEO',
        label: 'Geo',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'GEOMETRO',
          label: 'Metro',
        },
        {
          value: 'GEOOTH',
          label: 'Other Geo Models',
        },
        {
          value: 'GEOPRIZM',
          label: 'Prizm',
        },
        {
          value: 'SPECT',
          label: 'Spectrum',
        },
        {
          value: 'STORM',
          label: 'Storm',
        },
        {
          value: 'GEOTRACK',
          label: 'Tracker',
        },
      ],
    },
    {
      make: {
        value: 'GMC',
        label: 'GMC',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ACADIA',
          label: 'Acadia',
        },
        {
          value: 'CABALLERO',
          label: 'Caballero',
        },
        {
          value: 'CANYON',
          label: 'Canyon',
        },
        {
          value: 'ENVOY',
          label: 'Envoy',
        },
        {
          value: 'ENVOYXL',
          label: 'Envoy XL',
        },
        {
          value: 'ENVOYXUV',
          label: 'Envoy XUV',
        },
        {
          value: 'G1500',
          label: 'G1500',
        },
        {
          value: 'G2500',
          label: 'G2500',
        },
        {
          value: 'G3500',
          label: 'G3500',
        },
        {
          value: 'GMCHUMMER',
          label: 'Hummer EV',
        },
        {
          value: 'JIM',
          label: 'Jimmy',
        },
        {
          value: 'GMCOTH',
          label: 'Other GMC Models',
        },
        {
          value: 'GMCS15',
          label: 'S15 Jimmy',
        },
        {
          value: 'S15',
          label: 'S15 Pickup',
        },
        {
          value: 'SAFARIGMC',
          label: 'Safari',
        },
        {
          value: 'GMCSAVANA',
          label: 'Savana 1500',
        },
        {
          value: 'GMCSAV2500',
          label: 'Savana 2500',
        },
        {
          value: 'GMCSAV3500',
          label: 'Savana 3500',
        },
        {
          value: 'GMCSAV4500',
          label: 'Savana 4500',
        },
        {
          value: '15SIPU4WD',
          label: 'Sierra 1500',
        },
        {
          value: 'GMCC25PU',
          label: 'Sierra 2500',
        },
        {
          value: 'GMC3500PU',
          label: 'Sierra 3500',
        },
        {
          value: 'SONOMA',
          label: 'Sonoma',
        },
        {
          value: 'SUB',
          label: 'Suburban',
        },
        {
          value: 'GMCSYCLON',
          label: 'Syclone',
        },
        {
          value: 'TERRAIN',
          label: 'Terrain',
        },
        {
          value: 'TOPC4500',
          label: 'TopKick C4500',
        },
        {
          value: 'TYPH',
          label: 'Typhoon',
        },
        {
          value: 'YUKON',
          label: 'Yukon',
        },
        {
          value: 'YUKONXL',
          label: 'Yukon XL',
        },
      ],
    },
    {
      make: {
        value: 'HONDA',
        label: 'Honda',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ACCORD',
          label: 'Accord',
        },
        {
          value: 'CROSSTOUR',
          label: 'Accord Crosstour',
        },
        {
          value: 'CIVIC',
          label: 'Civic',
        },
        {
          value: 'HONCLARITY',
          label: 'Clarity',
        },
        {
          value: 'CRV',
          label: 'CR-V',
        },
        {
          value: 'CRZ',
          label: 'CR-Z',
        },
        {
          value: 'HONCROSS',
          label: 'Crosstour',
        },
        {
          value: 'CRX',
          label: 'CRX',
        },
        {
          value: 'HONDELSOL',
          label: 'Del Sol',
        },
        {
          value: 'ELEMENT',
          label: 'Element',
        },
        {
          value: 'FIT',
          label: 'Fit',
        },
        {
          value: 'HONHRV',
          label: 'HR-V',
        },
        {
          value: 'INSIGHT',
          label: 'Insight',
        },
        {
          value: 'ODYSSEY',
          label: 'Odyssey',
        },
        {
          value: 'HONOTH',
          label: 'Other Honda Models',
        },
        {
          value: 'PASSPO',
          label: 'Passport',
        },
        {
          value: 'PILOT',
          label: 'Pilot',
        },
        {
          value: 'PRE',
          label: 'Prelude',
        },
        {
          value: 'HONPROLOG',
          label: 'Prologue',
        },
        {
          value: 'RIDGELINE',
          label: 'Ridgeline',
        },
        {
          value: 'S2000',
          label: 'S2000',
        },
      ],
    },
    {
      make: {
        value: 'AMGEN',
        label: 'HUMMER',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'HUMMER',
          label: 'H1',
        },
        {
          value: 'H2',
          label: 'H2',
        },
        {
          value: 'H3',
          label: 'H3',
        },
        {
          value: 'H3T',
          label: 'H3T',
        },
        {
          value: 'AMGOTH',
          label: 'Other Hummer Models',
        },
      ],
    },
    {
      make: {
        value: 'HYUND',
        label: 'Hyundai',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ACCENT',
          label: 'Accent',
        },
        {
          value: 'AZERA',
          label: 'Azera',
        },
        {
          value: 'ELANTR',
          label: 'Elantra',
        },
        {
          value: 'HYUELANCPE',
          label: 'Elantra Coupe',
        },
        {
          value: 'HYUNDELANN',
          label: 'Elantra N',
        },
        {
          value: 'ELANTOUR',
          label: 'Elantra Touring',
        },
        {
          value: 'ENTOURAGE',
          label: 'Entourage',
        },
        {
          value: 'EQUUS',
          label: 'Equus',
        },
        {
          value: 'HYUEXCEL',
          label: 'Excel',
        },
        {
          value: 'GENESIS',
          label: 'Genesis',
        },
        {
          value: 'GENESISCPE',
          label: 'Genesis Coupe',
        },
        {
          value: 'HYUIONIQ',
          label: 'Ioniq',
        },
        {
          value: 'HYUIONIQ5',
          label: 'Ioniq 5',
        },
        {
          value: 'HYUIONIQ5N',
          label: 'Ioniq 5 N',
        },
        {
          value: 'HYUIONIQ6',
          label: 'Ioniq 6',
        },
        {
          value: 'HYUKONA',
          label: 'Kona',
        },
        {
          value: 'HYUNDKONAN',
          label: 'Kona N',
        },
        {
          value: 'HYUNDNEXO',
          label: 'Nexo',
        },
        {
          value: 'HYUOTH',
          label: 'Other Hyundai Models',
        },
        {
          value: 'HYUNDPALIS',
          label: 'Palisade',
        },
        {
          value: 'HYUNSANCR',
          label: 'Santa Cruz',
        },
        {
          value: 'SANTAFE',
          label: 'Santa Fe',
        },
        {
          value: 'SCOUPE',
          label: 'Scoupe',
        },
        {
          value: 'SONATA',
          label: 'Sonata',
        },
        {
          value: 'TIBURO',
          label: 'Tiburon',
        },
        {
          value: 'TUCSON',
          label: 'Tucson',
        },
        {
          value: 'VELOSTER',
          label: 'Veloster',
        },
        {
          value: 'HYUNDVELON',
          label: 'Veloster N',
        },
        {
          value: 'HYUNDVENUE',
          label: 'Venue',
        },
        {
          value: 'VERACRUZ',
          label: 'Veracruz',
        },
        {
          value: 'XG300',
          label: 'XG300',
        },
        {
          value: 'XG350',
          label: 'XG350',
        },
      ],
    },
    {
      make: {
        value: 'INEOS',
        label: 'INEOS',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'INEOSGREN',
          label: 'Grenadier',
        },
      ],
    },
    {
      make: {
        value: 'INFIN',
        label: 'INFINITI',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'EX_MODELS',
          label: 'EX Models',
        },
        {
          value: 'EX37',
          label: ' - EX37',
        },
        {
          value: 'EX35',
          label: ' - EX35',
        },
        {
          value: 'FX_MODELS',
          label: 'FX Models',
        },
        {
          value: 'FX35',
          label: ' - FX35',
        },
        {
          value: 'FX45',
          label: ' - FX45',
        },
        {
          value: 'FX37',
          label: ' - FX37',
        },
        {
          value: 'FX50',
          label: ' - FX50',
        },
        {
          value: 'G_MODELS',
          label: 'G Models',
        },
        {
          value: 'G20',
          label: ' - G20',
        },
        {
          value: 'G35',
          label: ' - G35',
        },
        {
          value: 'G25',
          label: ' - G25',
        },
        {
          value: 'G37',
          label: ' - G37',
        },
        {
          value: 'M_MODELS',
          label: 'M Models',
        },
        {
          value: 'M45',
          label: ' - M45',
        },
        {
          value: 'M35',
          label: ' - M35',
        },
        {
          value: 'M30',
          label: ' - M30',
        },
        {
          value: 'M35HYBRID',
          label: ' - M35h',
        },
        {
          value: 'M37',
          label: ' - M37',
        },
        {
          value: 'M56',
          label: ' - M56',
        },
        {
          value: 'I30',
          label: 'I30',
        },
        {
          value: 'I35',
          label: 'I35',
        },
        {
          value: 'J30',
          label: 'J30',
        },
        {
          value: 'JX35',
          label: 'JX35',
        },
        {
          value: 'INFOTH',
          label: 'Other Infiniti Models',
        },
        {
          value: 'INFINQ40',
          label: 'Q40',
        },
        {
          value: 'Q45',
          label: 'Q45',
        },
        {
          value: 'INFINQ50',
          label: 'Q50',
        },
        {
          value: 'INFINQ60',
          label: 'Q60',
        },
        {
          value: 'INFINQ70',
          label: 'Q70',
        },
        {
          value: 'INFINQX30',
          label: 'QX30',
        },
        {
          value: 'QX4',
          label: 'QX4',
        },
        {
          value: 'INFINQX50',
          label: 'QX50',
        },
        {
          value: 'INFINQX55',
          label: 'QX55',
        },
        {
          value: 'QX56',
          label: 'QX56',
        },
        {
          value: 'INFINQX60',
          label: 'QX60',
        },
        {
          value: 'INFINQX70',
          label: 'QX70',
        },
        {
          value: 'INFINQX80',
          label: 'QX80',
        },
      ],
    },
    {
      make: {
        value: 'ISU',
        label: 'Isuzu',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'AMIGO',
          label: 'Amigo',
        },
        {
          value: 'ASCENDER',
          label: 'Ascender',
        },
        {
          value: 'AXIOM',
          label: 'Axiom',
        },
        {
          value: 'HOMBRE',
          label: 'Hombre',
        },
        {
          value: 'I280',
          label: 'i-280',
        },
        {
          value: 'I290',
          label: 'i-290',
        },
        {
          value: 'I350',
          label: 'i-350',
        },
        {
          value: 'I370',
          label: 'i-370',
        },
        {
          value: 'ISUMARK',
          label: 'I-Mark',
        },
        {
          value: 'ISUIMP',
          label: 'Impulse',
        },
        {
          value: 'OASIS',
          label: 'Oasis',
        },
        {
          value: 'ISUOTH',
          label: 'Other Isuzu Models',
        },
        {
          value: 'ISUPU',
          label: 'Pickup',
        },
        {
          value: 'RODEO',
          label: 'Rodeo',
        },
        {
          value: 'STYLUS',
          label: 'Stylus',
        },
        {
          value: 'TROOP',
          label: 'Trooper',
        },
        {
          value: 'TRP2',
          label: 'Trooper II',
        },
        {
          value: 'VEHICROSS',
          label: 'VehiCROSS',
        },
      ],
    },
    {
      make: {
        value: 'JAG',
        label: 'Jaguar',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'XJ_SERIES',
          label: 'XJ Series',
        },
        {
          value: 'JAGXJ12',
          label: ' - XJ12',
        },
        {
          value: 'JAGXJ6',
          label: ' - XJ6',
        },
        {
          value: 'JAGXJR',
          label: ' - XJR',
        },
        {
          value: 'JAGXJS',
          label: ' - XJS',
        },
        {
          value: 'VANDEN',
          label: ' - XJ Vanden Plas',
        },
        {
          value: 'XJ',
          label: ' - XJ',
        },
        {
          value: 'XJ8',
          label: ' - XJ8',
        },
        {
          value: 'JAGXJRS',
          label: ' - XJR-S',
        },
        {
          value: 'XJ8L',
          label: ' - XJ8 L',
        },
        {
          value: 'XJSPORT',
          label: ' - XJ Sport',
        },
        {
          value: 'XK_SERIES',
          label: 'XK Series',
        },
        {
          value: 'JAGXK8',
          label: ' - XK8',
        },
        {
          value: 'XK',
          label: ' - XK',
        },
        {
          value: 'XKR',
          label: ' - XKR',
        },
        {
          value: 'JAGEPACE',
          label: 'E-PACE',
        },
        {
          value: 'JAGFPACE',
          label: 'F-PACE',
        },
        {
          value: 'JAGFTYPE',
          label: 'F-TYPE',
        },
        {
          value: 'JAGIPACE',
          label: 'I-PACE',
        },
        {
          value: 'JAGOTH',
          label: 'Other Jaguar Models',
        },
        {
          value: 'STYPE',
          label: 'S-TYPE',
        },
        {
          value: 'XTYPE',
          label: 'X-TYPE',
        },
        {
          value: 'JAGXE',
          label: 'XE',
        },
        {
          value: 'XF',
          label: 'XF',
        },
      ],
    },
    {
      make: {
        value: 'JEEP',
        label: 'Jeep',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'CHER',
          label: 'Cherokee',
        },
        {
          value: 'JEEPCJ',
          label: 'CJ',
        },
        {
          value: 'COMANC',
          label: 'Comanche',
        },
        {
          value: 'COMMANDER',
          label: 'Commander',
        },
        {
          value: 'COMPASS',
          label: 'Compass',
        },
        {
          value: 'JEEPGLAD',
          label: 'Gladiator',
        },
        {
          value: 'JEEPGRAND',
          label: 'Grand Cherokee',
        },
        {
          value: 'JEEPGRANDL',
          label: 'Grand Cherokee L',
        },
        {
          value: 'GRWAG',
          label: 'Grand Wagoneer',
        },
        {
          value: 'JEEPGRWAGL',
          label: 'Grand Wagoneer L',
        },
        {
          value: 'LIBERTY',
          label: 'Liberty',
        },
        {
          value: 'JEOTH',
          label: 'Other Jeep Models',
        },
        {
          value: 'PATRIOT',
          label: 'Patriot',
        },
        {
          value: 'JEEPPU',
          label: 'Pickup',
        },
        {
          value: 'JEEPRENEG',
          label: 'Renegade',
        },
        {
          value: 'SCRAMBLE',
          label: 'Scrambler',
        },
        {
          value: 'WAGONE',
          label: 'Wagoneer',
        },
        {
          value: 'JEEPWAGONL',
          label: 'Wagoneer L',
        },
        {
          value: 'WRANGLER',
          label: 'Wrangler',
        },
      ],
    },
    {
      make: {
        value: 'KARMA',
        label: 'Karma',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'KARMAGS6',
          label: 'GS-6',
        },
        {
          value: 'KARMREVERO',
          label: 'Revero',
        },
      ],
    },
    {
      make: {
        value: 'KIA',
        label: 'Kia',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'AMANTI',
          label: 'Amanti',
        },
        {
          value: 'BORREGO',
          label: 'Borrego',
        },
        {
          value: 'KIACADENZA',
          label: 'Cadenza',
        },
        {
          value: 'KIACARN',
          label: 'Carnival',
        },
        {
          value: 'KIAEV6',
          label: 'EV6',
        },
        {
          value: 'KIAEV9',
          label: 'EV9',
        },
        {
          value: 'FORTE',
          label: 'Forte',
        },
        {
          value: 'FORTEKOUP',
          label: 'Forte Koup',
        },
        {
          value: 'KIAK5',
          label: 'K5',
        },
        {
          value: 'KIAK900',
          label: 'K900',
        },
        {
          value: 'KIANIRO',
          label: 'Niro',
        },
        {
          value: 'OPTIMA',
          label: 'Optima',
        },
        {
          value: 'KIAOTH',
          label: 'Other Kia Models',
        },
        {
          value: 'RIO',
          label: 'Rio',
        },
        {
          value: 'RIO5',
          label: 'Rio5',
        },
        {
          value: 'RONDO',
          label: 'Rondo',
        },
        {
          value: 'SEDONA',
          label: 'Sedona',
        },
        {
          value: 'KIASELTOS',
          label: 'Seltos',
        },
        {
          value: 'SEPHIA',
          label: 'Sephia',
        },
        {
          value: 'SORENTO',
          label: 'Sorento',
        },
        {
          value: 'SOUL',
          label: 'Soul',
        },
        {
          value: 'SPECTRA',
          label: 'Spectra',
        },
        {
          value: 'SPECTRA5',
          label: 'Spectra5',
        },
        {
          value: 'SPORTA',
          label: 'Sportage',
        },
        {
          value: 'KIASTING',
          label: 'Stinger',
        },
        {
          value: 'KIATELLURD',
          label: 'Telluride',
        },
      ],
    },
    {
      make: {
        value: 'LAM',
        label: 'Lamborghini',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'AVENT',
          label: 'Aventador',
        },
        {
          value: 'LAMCENTEN',
          label: 'Centenario',
        },
        {
          value: 'COUNT',
          label: 'Countach',
        },
        {
          value: 'DIABLO',
          label: 'Diablo',
        },
        {
          value: 'GALLARDO',
          label: 'Gallardo',
        },
        {
          value: 'LAMHURACAN',
          label: 'Huracan',
        },
        {
          value: 'JALPA',
          label: 'Jalpa',
        },
        {
          value: 'LM002',
          label: 'LM002',
        },
        {
          value: 'MURCIELAGO',
          label: 'Murcielago',
        },
        {
          value: 'LAMOTH',
          label: 'Other Lamborghini Models',
        },
        {
          value: 'LAMSIAN',
          label: 'Sian',
        },
        {
          value: 'LAMURUS',
          label: 'Urus',
        },
      ],
    },
    {
      make: {
        value: 'ROV',
        label: 'Land Rover',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'DEFEND',
          label: 'Defender',
        },
        {
          value: 'DISCOV',
          label: 'Discovery',
        },
        {
          value: 'ROVDISCSPT',
          label: 'Discovery Sport',
        },
        {
          value: 'FRELNDR',
          label: 'Freelander',
        },
        {
          value: 'LR2',
          label: 'LR2',
        },
        {
          value: 'LR3',
          label: 'LR3',
        },
        {
          value: 'LR4',
          label: 'LR4',
        },
        {
          value: 'ROVOTH',
          label: 'Other Land Rover Models',
        },
        {
          value: 'RANGE',
          label: 'Range Rover',
        },
        {
          value: 'EVOQUE',
          label: 'Range Rover Evoque',
        },
        {
          value: 'RANGESPORT',
          label: 'Range Rover Sport',
        },
        {
          value: 'ROVVELAR',
          label: 'Range Rover Velar',
        },
      ],
    },
    {
      make: {
        value: 'LEXUS',
        label: 'Lexus',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ES_MODELS',
          label: 'ES Models',
        },
        {
          value: 'ES300',
          label: ' - ES 300',
        },
        {
          value: 'ES330',
          label: ' - ES 330',
        },
        {
          value: 'ES250',
          label: ' - ES 250',
        },
        {
          value: 'ES350',
          label: ' - ES 350',
        },
        {
          value: 'ES300H',
          label: ' - ES 300h',
        },
        {
          value: 'GS_MODELS',
          label: 'GS Models',
        },
        {
          value: 'GS400',
          label: ' - GS 400',
        },
        {
          value: 'GS450H',
          label: ' - GS 450h',
        },
        {
          value: 'GS350',
          label: ' - GS 350',
        },
        {
          value: 'GS300',
          label: ' - GS 300',
        },
        {
          value: 'LEXGS200T',
          label: ' - GS 200t',
        },
        {
          value: 'GS430',
          label: ' - GS 430',
        },
        {
          value: 'LEXGSF',
          label: ' - GS F',
        },
        {
          value: 'GS460',
          label: ' - GS 460',
        },
        {
          value: 'GX_MODELS',
          label: 'GX Models',
        },
        {
          value: 'GX470',
          label: ' - GX 470',
        },
        {
          value: 'GX460',
          label: ' - GX 460',
        },
        {
          value: 'LEXGX550',
          label: ' - GX 550',
        },
        {
          value: 'IS_MODELS',
          label: 'IS Models',
        },
        {
          value: 'IS350',
          label: ' - IS 350',
        },
        {
          value: 'IS250',
          label: ' - IS 250',
        },
        {
          value: 'IS300',
          label: ' - IS 300',
        },
        {
          value: 'ISF',
          label: ' - IS F',
        },
        {
          value: 'IS250C',
          label: ' - IS 250C',
        },
        {
          value: 'IS350C',
          label: ' - IS 350C',
        },
        {
          value: 'LEXIS200T',
          label: ' - IS 200t',
        },
        {
          value: 'LEXIS500',
          label: ' - IS 500',
        },
        {
          value: 'LC_MODELS',
          label: 'LC Models',
        },
        {
          value: 'LEXLC500H',
          label: ' - LC 500h',
        },
        {
          value: 'LEXLC500',
          label: ' - LC 500',
        },
        {
          value: 'LS_MODELS',
          label: 'LS Models',
        },
        {
          value: 'LS400',
          label: ' - LS 400',
        },
        {
          value: 'LS460',
          label: ' - LS 460',
        },
        {
          value: 'LS430',
          label: ' - LS 430',
        },
        {
          value: 'LS600H',
          label: ' - LS 600h',
        },
        {
          value: 'LEXLS500',
          label: ' - LS 500',
        },
        {
          value: 'LEXLS500H',
          label: ' - LS 500h',
        },
        {
          value: 'LX_MODELS',
          label: 'LX Models',
        },
        {
          value: 'LX450',
          label: ' - LX 450',
        },
        {
          value: 'LX470',
          label: ' - LX 470',
        },
        {
          value: 'LX570',
          label: ' - LX 570',
        },
        {
          value: 'LEXLX600',
          label: ' - LX 600',
        },
        {
          value: 'NX_MODELS',
          label: 'NX Models',
        },
        {
          value: 'LEXNX200T',
          label: ' - NX 200t',
        },
        {
          value: 'LEXNX300H',
          label: ' - NX 300h',
        },
        {
          value: 'LEXNX300',
          label: ' - NX 300',
        },
        {
          value: 'LEXNX250',
          label: ' - NX 250',
        },
        {
          value: 'LEXNX350',
          label: ' - NX 350',
        },
        {
          value: 'LEXNX350H',
          label: ' - NX 350h',
        },
        {
          value: 'LEXNX450H',
          label: ' - NX 450h+',
        },
        {
          value: 'RC_MODELS',
          label: 'RC Models',
        },
        {
          value: 'LEXRC200T',
          label: ' - RC 200t',
        },
        {
          value: 'LEXRC350',
          label: ' - RC 350',
        },
        {
          value: 'LEXRCF',
          label: ' - RC F',
        },
        {
          value: 'LEXRC300',
          label: ' - RC 300',
        },
        {
          value: 'RX_MODELS',
          label: 'RX Models',
        },
        {
          value: 'RX300',
          label: ' - RX 300',
        },
        {
          value: 'RX330',
          label: ' - RX 330',
        },
        {
          value: 'RX400H',
          label: ' - RX 400h',
        },
        {
          value: 'RX350',
          label: ' - RX 350',
        },
        {
          value: 'RX450H',
          label: ' - RX 450h',
        },
        {
          value: 'LEXRX350L',
          label: ' - RX 350L',
        },
        {
          value: 'LEXRX450HL',
          label: ' - RX 450hL',
        },
        {
          value: 'LEXRX350H',
          label: ' - RX 350h',
        },
        {
          value: 'LEXRX500H',
          label: ' - RX 500h',
        },
        {
          value: 'RZ_MODELS',
          label: 'RZ Models',
        },
        {
          value: 'LEXRZ300E',
          label: ' - RZ 300e',
        },
        {
          value: 'LEXRZ450E',
          label: ' - RZ 450e',
        },
        {
          value: 'SC_MODELS',
          label: 'SC Models',
        },
        {
          value: 'SC300',
          label: ' - SC 300',
        },
        {
          value: 'SC400',
          label: ' - SC 400',
        },
        {
          value: 'SC430',
          label: ' - SC 430',
        },
        {
          value: 'TX_MODELS',
          label: 'TX Models',
        },
        {
          value: 'LEXTX550H',
          label: ' - TX 550h',
        },
        {
          value: 'LEXTX350',
          label: ' - TX 350',
        },
        {
          value: 'LEXTX500H',
          label: ' - TX 500h',
        },
        {
          value: 'UX_MODELS',
          label: 'UX Models',
        },
        {
          value: 'LEXUX200',
          label: ' - UX 200',
        },
        {
          value: 'LEXUX250H',
          label: ' - UX 250h',
        },
        {
          value: 'LEXUX300H',
          label: ' - UX 300h',
        },
        {
          value: 'CT200H',
          label: 'CT 200h',
        },
        {
          value: 'HS250H',
          label: 'HS 250h',
        },
        {
          value: 'LEXLFA',
          label: 'LFA',
        },
        {
          value: 'LEXOTH',
          label: 'Other Lexus Models',
        },
      ],
    },
    {
      make: {
        value: 'LINC',
        label: 'Lincoln',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'AVIATOR',
          label: 'Aviator',
        },
        {
          value: 'BLKWOOD',
          label: 'Blackwood',
        },
        {
          value: 'CONT',
          label: 'Continental',
        },
        {
          value: 'LINCCORS',
          label: 'Corsair',
        },
        {
          value: 'LSLINCOLN',
          label: 'LS',
        },
        {
          value: 'MARKLT',
          label: 'Mark LT',
        },
        {
          value: 'MARK6',
          label: 'Mark VI',
        },
        {
          value: 'MARK7',
          label: 'Mark VII',
        },
        {
          value: 'MARK8',
          label: 'Mark VIII',
        },
        {
          value: 'LINCMKC',
          label: 'MKC',
        },
        {
          value: 'MKS',
          label: 'MKS',
        },
        {
          value: 'MKT',
          label: 'MKT',
        },
        {
          value: 'MKX',
          label: 'MKX',
        },
        {
          value: 'MKZ',
          label: 'MKZ',
        },
        {
          value: 'LINCNAUT',
          label: 'Nautilus',
        },
        {
          value: 'NAVIGA',
          label: 'Navigator',
        },
        {
          value: 'NAVIGAL',
          label: 'Navigator L',
        },
        {
          value: 'LINOTH',
          label: 'Other Lincoln Models',
        },
        {
          value: 'LINCTC',
          label: 'Town Car',
        },
        {
          value: 'ZEPHYR',
          label: 'Zephyr',
        },
      ],
    },
    {
      make: {
        value: 'LOTUS',
        label: 'Lotus',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ELAN',
          label: 'Elan',
        },
        {
          value: 'LOTELISE',
          label: 'Elise',
        },
        {
          value: 'LOTEMIRA',
          label: 'Emira',
        },
        {
          value: 'ESPRIT',
          label: 'Esprit',
        },
        {
          value: 'EVORA',
          label: 'Evora',
        },
        {
          value: 'EXIGE',
          label: 'Exige',
        },
        {
          value: 'LOTOTH',
          label: 'Other Lotus Models',
        },
      ],
    },
    {
      make: {
        value: 'LUCID',
        label: 'Lucid',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'LUCIDAIR',
          label: 'Air',
        },
      ],
    },
    {
      make: {
        value: 'MAS',
        label: 'Maserati',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: '430',
          label: '430',
        },
        {
          value: 'BITRBO',
          label: 'Biturbo',
        },
        {
          value: 'COUPEMAS',
          label: 'Coupe',
        },
        {
          value: 'GHIB',
          label: 'Ghibli',
        },
        {
          value: 'GRANSPORT',
          label: 'GranSport',
        },
        {
          value: 'GRANTURISM',
          label: 'GranTurismo',
        },
        {
          value: 'MASGRECALE',
          label: 'Grecale',
        },
        {
          value: 'MASLEVAN',
          label: 'Levante',
        },
        {
          value: 'MASMC20',
          label: 'MC20',
        },
        {
          value: 'MASOTH',
          label: 'Other Maserati Models',
        },
        {
          value: 'QP',
          label: 'Quattroporte',
        },
        {
          value: 'SPYDER',
          label: 'Spyder',
        },
      ],
    },
    {
      make: {
        value: 'MAYBACH',
        label: 'Maybach',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: '57MAYBACH',
          label: '57',
        },
        {
          value: '62MAYBACH',
          label: '62',
        },
        {
          value: 'MAYOTH',
          label: 'Other Maybach Models',
        },
      ],
    },
    {
      make: {
        value: 'MAZDA',
        label: 'MAZDA',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'MAZDA323',
          label: '323',
        },
        {
          value: 'MAZDA626',
          label: '626',
        },
        {
          value: '929',
          label: '929',
        },
        {
          value: 'B-SERIES',
          label: 'B-Series Pickup',
        },
        {
          value: 'MAZCX3',
          label: 'CX-3',
        },
        {
          value: 'MAZCX30',
          label: 'CX-30',
        },
        {
          value: 'CX-5',
          label: 'CX-5',
        },
        {
          value: 'MAZCX50',
          label: 'CX-50',
        },
        {
          value: 'CX-7',
          label: 'CX-7',
        },
        {
          value: 'CX-9',
          label: 'CX-9',
        },
        {
          value: 'MAZCX90',
          label: 'CX-90',
        },
        {
          value: 'GLC',
          label: 'GLC',
        },
        {
          value: 'MAZDA2',
          label: 'MAZDA2',
        },
        {
          value: 'MAZDA3',
          label: 'MAZDA3',
        },
        {
          value: 'MAZDA5',
          label: 'MAZDA5',
        },
        {
          value: 'MAZDA6',
          label: 'MAZDA6',
        },
        {
          value: 'MAZDASPD3',
          label: 'MAZDASPEED3',
        },
        {
          value: 'MAZDASPD6',
          label: 'MAZDASPEED6',
        },
        {
          value: 'MILL',
          label: 'Millenia',
        },
        {
          value: 'MPV',
          label: 'MPV',
        },
        {
          value: 'MAZMX30',
          label: 'MX-30',
        },
        {
          value: 'MIATA',
          label: 'MX-5 Miata',
        },
        {
          value: 'MAZMIATARF',
          label: 'MX-5 Miata RF',
        },
        {
          value: 'MX3',
          label: 'MX3',
        },
        {
          value: 'MX6',
          label: 'MX6',
        },
        {
          value: 'NAVAJO',
          label: 'Navajo',
        },
        {
          value: 'MAZOTH',
          label: 'Other Mazda Models',
        },
        {
          value: 'PROTE',
          label: 'Protege',
        },
        {
          value: 'PROTE5',
          label: 'Protege5',
        },
        {
          value: 'RX7',
          label: 'RX-7',
        },
        {
          value: 'RX8',
          label: 'RX-8',
        },
        {
          value: 'TRIBUTE',
          label: 'Tribute',
        },
      ],
    },
    {
      make: {
        value: 'MCLAREN',
        label: 'McLaren',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'MCL570GT',
          label: '570GT',
        },
        {
          value: 'MCL570S',
          label: '570S',
        },
        {
          value: 'MCL600LT',
          label: '600LT',
        },
        {
          value: 'MCL620R',
          label: '620R',
        },
        {
          value: 'MCL650S',
          label: '650S',
        },
        {
          value: 'MCL675LT',
          label: '675LT',
        },
        {
          value: 'MCL720S',
          label: '720S',
        },
        {
          value: 'MCL750S',
          label: '750S',
        },
        {
          value: 'MCL765LT',
          label: '765LT',
        },
        {
          value: 'MCLARTURA',
          label: 'Artura',
        },
        {
          value: 'MCLELVA',
          label: 'Elva',
        },
        {
          value: 'MCLGT',
          label: 'GT',
        },
        {
          value: 'MP4',
          label: 'MP4-12C',
        },
        {
          value: 'MCLOTH',
          label: 'Other McLaren Models',
        },
        {
          value: 'MCLP1',
          label: 'P1',
        },
        {
          value: 'MCLSABRE',
          label: 'Sabre',
        },
        {
          value: 'MCLSENNA',
          label: 'Senna',
        },
        {
          value: 'MCLSPEEDT',
          label: 'Speedtail',
        },
      ],
    },
    {
      make: {
        value: 'MB',
        label: 'Mercedes-Benz',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'A_CLASS',
          label: 'A-Class',
        },
        {
          value: 'MBA220',
          label: ' - A 220',
        },
        {
          value: 'MBA35AMG',
          label: ' - A 35 AMG',
        },
        {
          value: 'B_CLASS',
          label: 'B-Class',
        },
        {
          value: 'MBB250E',
          label: ' - B 250e',
        },
        {
          value: 'MBBCLASSED',
          label: ' - B-Class Electric Drive',
        },
        {
          value: 'C_CLASS',
          label: 'C-Class',
        },
        {
          value: 'C220',
          label: ' - C 220',
        },
        {
          value: 'C230',
          label: ' - C 230',
        },
        {
          value: 'C280',
          label: ' - C 280',
        },
        {
          value: 'C55AMG',
          label: ' - C 55 AMG',
        },
        {
          value: 'MBC400',
          label: ' - C 400',
        },
        {
          value: 'C350',
          label: ' - C 350',
        },
        {
          value: 'C32AMG',
          label: ' - C 32 AMG',
        },
        {
          value: 'C320',
          label: ' - C 320',
        },
        {
          value: 'C240',
          label: ' - C 240',
        },
        {
          value: 'C300',
          label: ' - C 300',
        },
        {
          value: 'C250',
          label: ' - C 250',
        },
        {
          value: 'C36AMG',
          label: ' - C 36 AMG',
        },
        {
          value: 'C43AMG',
          label: ' - C 43 AMG',
        },
        {
          value: 'MBC450',
          label: ' - C 450',
        },
        {
          value: 'MBC350E',
          label: ' - C 350e',
        },
        {
          value: 'C63AMG',
          label: ' - C 63 AMG',
        },
        {
          value: 'CL_CLASS',
          label: 'CL-Class',
        },
        {
          value: 'CL65AMG',
          label: ' - CL 65 AMG',
        },
        {
          value: 'CL500',
          label: ' - CL 500',
        },
        {
          value: 'CL600',
          label: ' - CL 600',
        },
        {
          value: 'CL550',
          label: ' - CL 550',
        },
        {
          value: 'CL63AMG',
          label: ' - CL 63 AMG',
        },
        {
          value: 'CL55AMG',
          label: ' - CL 55 AMG',
        },
        {
          value: 'CLA_CLASS',
          label: 'CLA-Class',
        },
        {
          value: 'MBCLA250',
          label: ' - CLA 250',
        },
        {
          value: 'MBCLA45AMG',
          label: ' - CLA 45 AMG',
        },
        {
          value: 'MBCLA35AMG',
          label: ' - CLA 35 AMG',
        },
        {
          value: 'CLE_CLASS',
          label: 'CLE-Class',
        },
        {
          value: 'MBCLE300',
          label: ' - CLE 300',
        },
        {
          value: 'MBCLE450',
          label: ' - CLE 450',
        },
        {
          value: 'CLK_CLASS',
          label: 'CLK-Class',
        },
        {
          value: 'CLK500',
          label: ' - CLK 500',
        },
        {
          value: 'CLK350',
          label: ' - CLK 350',
        },
        {
          value: 'CLK550',
          label: ' - CLK 550',
        },
        {
          value: 'CLK63AMG',
          label: ' - CLK 63 AMG',
        },
        {
          value: 'CLK320',
          label: ' - CLK 320',
        },
        {
          value: 'CLK430',
          label: ' - CLK 430',
        },
        {
          value: 'CLK55AMG',
          label: ' - CLK 55 AMG',
        },
        {
          value: 'CLS_CLASS',
          label: 'CLS-Class',
        },
        {
          value: 'CLS500',
          label: ' - CLS 500',
        },
        {
          value: 'CLS55AMG',
          label: ' - CLS 55 AMG',
        },
        {
          value: 'CLS550',
          label: ' - CLS 550',
        },
        {
          value: 'CLS63AMG',
          label: ' - CLS 63 AMG',
        },
        {
          value: 'MBCLS400',
          label: ' - CLS 400',
        },
        {
          value: 'MBCLS450',
          label: ' - CLS 450',
        },
        {
          value: 'MBCLS53AMG',
          label: ' - CLS 53 AMG',
        },
        {
          value: 'E_CLASS',
          label: 'E-Class',
        },
        {
          value: 'E320',
          label: ' - E 320',
        },
        {
          value: 'E420',
          label: ' - E 420',
        },
        {
          value: 'E430',
          label: ' - E 430',
        },
        {
          value: 'E500',
          label: ' - E 500',
        },
        {
          value: 'E350',
          label: ' - E 350',
        },
        {
          value: 'E63AMG',
          label: ' - E 63 AMG',
        },
        {
          value: 'E550',
          label: ' - E 550',
        },
        {
          value: 'MBE250BLUE',
          label: ' - E 250',
        },
        {
          value: 'MBE43AMG',
          label: ' - E 43 AMG',
        },
        {
          value: 'E55AMG',
          label: ' - E 55 AMG',
        },
        {
          value: 'E300',
          label: ' - E 300',
        },
        {
          value: 'MBE400',
          label: ' - E 400',
        },
        {
          value: 'MBE53AMG',
          label: ' - E 53 AMG',
        },
        {
          value: 'MBE450',
          label: ' - E 450',
        },
        {
          value: 'EQB_CLASS',
          label: 'EQB-Class',
        },
        {
          value: 'MBEQB350',
          label: ' - EQB 350',
        },
        {
          value: 'MBEQB300',
          label: ' - EQB 300',
        },
        {
          value: 'MBEQB250',
          label: ' - EQB 250+',
        },
        {
          value: 'EQE_CLASS',
          label: 'EQE-Class',
        },
        {
          value: 'MBEQE350',
          label: ' - EQE 350+',
        },
        {
          value: 'MBEQEAMG',
          label: ' - EQE AMG',
        },
        {
          value: 'MBEQE500',
          label: ' - EQE 500',
        },
        {
          value: 'EQS_CLASS',
          label: 'EQS-Class',
        },
        {
          value: 'MBEQSAMG',
          label: ' - EQS AMG',
        },
        {
          value: 'MBEQS680',
          label: ' - Maybach EQS 680',
        },
        {
          value: 'MBEQS450',
          label: ' - EQS 450+',
        },
        {
          value: 'MBEQS580',
          label: ' - EQS 580',
        },
        {
          value: 'G_CLASS',
          label: 'G-Class',
        },
        {
          value: 'G55AMG',
          label: ' - G 55 AMG',
        },
        {
          value: 'G500',
          label: ' - G 500',
        },
        {
          value: 'G550',
          label: ' - G 550',
        },
        {
          value: 'MBG65AMG',
          label: ' - G 65 AMG',
        },
        {
          value: 'G63AMG',
          label: ' - G 63 AMG',
        },
        {
          value: 'GL_CLASS',
          label: 'GL-Class',
        },
        {
          value: 'GL450',
          label: ' - GL 450',
        },
        {
          value: 'GL63AMG',
          label: ' - GL 63 AMG',
        },
        {
          value: 'GL550',
          label: ' - GL 550',
        },
        {
          value: 'GL350BLUE',
          label: ' - GL 350',
        },
        {
          value: 'GL320BLUE',
          label: ' - GL 320',
        },
        {
          value: 'GLA_CLASS',
          label: 'GLA-Class',
        },
        {
          value: 'MBGLA250',
          label: ' - GLA 250',
        },
        {
          value: 'MBGLA45AMG',
          label: ' - GLA 45 AMG',
        },
        {
          value: 'MBGLA35AMG',
          label: ' - GLA 35 AMG',
        },
        {
          value: 'GLB_CLASS',
          label: 'GLB-Class',
        },
        {
          value: 'MBGLB35AMG',
          label: ' - GLB 35 AMG',
        },
        {
          value: 'MBGLB250',
          label: ' - GLB 250',
        },
        {
          value: 'GLC_CLASS',
          label: 'GLC-Class',
        },
        {
          value: 'MBGLC43AMG',
          label: ' - GLC 43 AMG',
        },
        {
          value: 'MBGLC350E',
          label: ' - GLC 350e',
        },
        {
          value: 'MBGLC63AMG',
          label: ' - GLC 63 AMG',
        },
        {
          value: 'MBGLC300',
          label: ' - GLC 300',
        },
        {
          value: 'GLE_CLASS',
          label: 'GLE-Class',
        },
        {
          value: 'MBGLE300D',
          label: ' - GLE 300d',
        },
        {
          value: 'MBGLE350',
          label: ' - GLE 350',
        },
        {
          value: 'MBGLE400',
          label: ' - GLE 400',
        },
        {
          value: 'MBGLE450',
          label: ' - GLE 450',
        },
        {
          value: 'MBGLE63AMG',
          label: ' - GLE 63 AMG',
        },
        {
          value: 'MBGLE550E',
          label: ' - GLE 550e',
        },
        {
          value: 'MBGLE43AMG',
          label: ' - GLE 43 AMG',
        },
        {
          value: 'MBGLE450E',
          label: ' - GLE 450e',
        },
        {
          value: 'MBGLE580',
          label: ' - GLE 580',
        },
        {
          value: 'MBGLE53AMG',
          label: ' - GLE 53 AMG',
        },
        {
          value: 'GLK_CLASS',
          label: 'GLK-Class',
        },
        {
          value: 'GLK250BLUE',
          label: ' - GLK 250',
        },
        {
          value: 'GLK350',
          label: ' - GLK 350',
        },
        {
          value: 'GLS_CLASS',
          label: 'GLS-Class',
        },
        {
          value: 'MBGLS350D',
          label: ' - GLS 350d',
        },
        {
          value: 'MBGLS450',
          label: ' - GLS 450',
        },
        {
          value: 'MBGLS550',
          label: ' - GLS 550',
        },
        {
          value: 'MBGLS63AMG',
          label: ' - GLS 63 AMG',
        },
        {
          value: 'MBMGLS600',
          label: ' - Maybach GLS 600',
        },
        {
          value: 'MBGLS580',
          label: ' - GLS 580',
        },
        {
          value: 'M_CLASS',
          label: 'M-Class',
        },
        {
          value: 'ML350',
          label: ' - ML 350',
        },
        {
          value: 'ML320',
          label: ' - ML 320',
        },
        {
          value: 'ML63AMG',
          label: ' - ML 63 AMG',
        },
        {
          value: 'ML500',
          label: ' - ML 500',
        },
        {
          value: 'ML430',
          label: ' - ML 430',
        },
        {
          value: 'MBML250BLU',
          label: ' - ML 250',
        },
        {
          value: 'MBML400',
          label: ' - ML 400',
        },
        {
          value: 'ML550',
          label: ' - ML 550',
        },
        {
          value: 'ML450HY',
          label: ' - ML 450',
        },
        {
          value: 'ML55AMG',
          label: ' - ML 55 AMG',
        },
        {
          value: 'R_CLASS',
          label: 'R-Class',
        },
        {
          value: 'R350',
          label: ' - R 350',
        },
        {
          value: 'R500',
          label: ' - R 500',
        },
        {
          value: 'R63AMG',
          label: ' - R 63 AMG',
        },
        {
          value: 'R320BLUE',
          label: ' - R 320',
        },
        {
          value: 'S_CLASS',
          label: 'S-Class',
        },
        {
          value: 'MBS550E',
          label: ' - S 550e',
        },
        {
          value: 'S320',
          label: ' - S 320',
        },
        {
          value: 'S420',
          label: ' - S 420',
        },
        {
          value: 'S500',
          label: ' - S 500',
        },
        {
          value: 'S65AMG',
          label: ' - S 65 AMG',
        },
        {
          value: 'S350',
          label: ' - S 350',
        },
        {
          value: 'S550',
          label: ' - S 550',
        },
        {
          value: 'S600',
          label: ' - S 600',
        },
        {
          value: 'S430',
          label: ' - S 430',
        },
        {
          value: 'MBMAYS600',
          label: ' - Maybach S 600',
        },
        {
          value: 'S63AMG',
          label: ' - S 63 AMG',
        },
        {
          value: 'MBS450',
          label: ' - S 450',
        },
        {
          value: 'MBMAYS560',
          label: ' - Maybach S 560',
        },
        {
          value: 'MBS560',
          label: ' - S 560',
        },
        {
          value: 'MBMAYS650',
          label: ' - Maybach S 650',
        },
        {
          value: 'S400HY',
          label: ' - S 400',
        },
        {
          value: 'S55AMG',
          label: ' - S 55 AMG',
        },
        {
          value: 'MBMAYS550',
          label: ' - Maybach S 550',
        },
        {
          value: 'MBS560E',
          label: ' - S 560e',
        },
        {
          value: 'MBMAYS680',
          label: ' - Maybach S 680',
        },
        {
          value: 'MBS580E',
          label: ' - S 580e',
        },
        {
          value: 'MBS580',
          label: ' - S 580',
        },
        {
          value: 'MBMAYS580',
          label: ' - Maybach S 580',
        },
        {
          value: 'SL_CLASS',
          label: 'SL-Class',
        },
        {
          value: 'SL55AMG',
          label: ' - SL 55 AMG',
        },
        {
          value: 'SL320',
          label: ' - SL 320',
        },
        {
          value: 'SL600',
          label: ' - SL 600',
        },
        {
          value: 'SL65AMG',
          label: ' - SL 65 AMG',
        },
        {
          value: 'SL500',
          label: ' - SL 500',
        },
        {
          value: 'SL550',
          label: ' - SL 550',
        },
        {
          value: 'MBSL400',
          label: ' - SL 400',
        },
        {
          value: 'SL63AMG',
          label: ' - SL 63 AMG',
        },
        {
          value: 'MBSL450',
          label: ' - SL 450',
        },
        {
          value: 'MBSL43AMG',
          label: ' - SL 43 AMG',
        },
        {
          value: 'SLC_CLASS',
          label: 'SLC-Class',
        },
        {
          value: 'MBSLC300',
          label: ' - SLC 300',
        },
        {
          value: 'MBSLC43AMG',
          label: ' - SLC 43 AMG',
        },
        {
          value: 'SLK_CLASS',
          label: 'SLK-Class',
        },
        {
          value: 'SLK350',
          label: ' - SLK 350',
        },
        {
          value: 'SLK55AMG',
          label: ' - SLK 55 AMG',
        },
        {
          value: 'SLK280',
          label: ' - SLK 280',
        },
        {
          value: 'SLK32AMG',
          label: ' - SLK 32 AMG',
        },
        {
          value: 'SLK230',
          label: ' - SLK 230',
        },
        {
          value: 'SLK320',
          label: ' - SLK 320',
        },
        {
          value: 'SLK250',
          label: ' - SLK 250',
        },
        {
          value: 'SLK300',
          label: ' - SLK 300',
        },
        {
          value: 'SPRINTER_CLASS',
          label: 'Sprinter-Class',
        },
        {
          value: 'MBSPRINTER',
          label: ' - Sprinter',
        },
        {
          value: 'MBESPRINT',
          label: ' - eSprinter',
        },
        {
          value: '190D',
          label: '190 D',
        },
        {
          value: '190E',
          label: '190 E',
        },
        {
          value: '240D',
          label: '240 D',
        },
        {
          value: '260E',
          label: '260 E',
        },
        {
          value: '280CE',
          label: '280 CE',
        },
        {
          value: '280E',
          label: '280 E',
        },
        {
          value: '300CD',
          label: '300 CD',
        },
        {
          value: '300CE',
          label: '300 CE',
        },
        {
          value: '300D',
          label: '300 D',
        },
        {
          value: '300E',
          label: '300 E',
        },
        {
          value: '300SD',
          label: '300 SD',
        },
        {
          value: '300SDL',
          label: '300 SDL',
        },
        {
          value: '300SE',
          label: '300 SE',
        },
        {
          value: '300SEL',
          label: '300 SEL',
        },
        {
          value: '300SL',
          label: '300 SL',
        },
        {
          value: '300TD',
          label: '300 TD',
        },
        {
          value: '300TE',
          label: '300 TE',
        },
        {
          value: '350SD',
          label: '350 SD',
        },
        {
          value: '350SDL',
          label: '350 SDL',
        },
        {
          value: '380SE',
          label: '380 SE',
        },
        {
          value: '380SEC',
          label: '380 SEC',
        },
        {
          value: '380SEL',
          label: '380 SEL',
        },
        {
          value: '380SL',
          label: '380 SL',
        },
        {
          value: '380SLC',
          label: '380 SLC',
        },
        {
          value: '400E',
          label: '400 E',
        },
        {
          value: '400SE',
          label: '400 SE',
        },
        {
          value: '400SEL',
          label: '400 SEL',
        },
        {
          value: '420SEL',
          label: '420 SEL',
        },
        {
          value: '500E',
          label: '500 E',
        },
        {
          value: '500SEC',
          label: '500 SEC',
        },
        {
          value: '500SEL',
          label: '500 SEL',
        },
        {
          value: '500SL',
          label: '500 SL',
        },
        {
          value: '560SEC',
          label: '560 SEC',
        },
        {
          value: '560SEL',
          label: '560 SEL',
        },
        {
          value: '560SL',
          label: '560 SL',
        },
        {
          value: '600SEC',
          label: '600 SEC',
        },
        {
          value: '600SEL',
          label: '600 SEL',
        },
        {
          value: '600SL',
          label: '600 SL',
        },
        {
          value: 'MBAMGGT',
          label: 'AMG GT',
        },
        {
          value: 'MBMETRIS',
          label: 'Metris',
        },
        {
          value: 'MBOTH',
          label: 'Other Mercedes-Benz Models',
        },
        {
          value: 'SLR',
          label: 'SLR',
        },
        {
          value: 'SLSAMG',
          label: 'SLS AMG',
        },
      ],
    },
    {
      make: {
        value: 'MERC',
        label: 'Mercury',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'CAPRI',
          label: 'Capri',
        },
        {
          value: 'COUGAR',
          label: 'Cougar',
        },
        {
          value: 'MERCGRAND',
          label: 'Grand Marquis',
        },
        {
          value: 'LN7',
          label: 'LN7',
        },
        {
          value: 'LYNX',
          label: 'Lynx',
        },
        {
          value: 'MARAUDER',
          label: 'Marauder',
        },
        {
          value: 'MARINER',
          label: 'Mariner',
        },
        {
          value: 'MARQ',
          label: 'Marquis',
        },
        {
          value: 'MILAN',
          label: 'Milan',
        },
        {
          value: 'MONTEGO',
          label: 'Montego',
        },
        {
          value: 'MONTEREY',
          label: 'Monterey',
        },
        {
          value: 'MOUNTA',
          label: 'Mountaineer',
        },
        {
          value: 'MYSTIQ',
          label: 'Mystique',
        },
        {
          value: 'MEOTH',
          label: 'Other Mercury Models',
        },
        {
          value: 'SABLE',
          label: 'Sable',
        },
        {
          value: 'TOPAZ',
          label: 'Topaz',
        },
        {
          value: 'TRACER',
          label: 'Tracer',
        },
        {
          value: 'VILLA',
          label: 'Villager',
        },
        {
          value: 'MERCZEP',
          label: 'Zephyr',
        },
      ],
    },
    {
      make: {
        value: 'MINI',
        label: 'MINI',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'COOPER',
          label: 'Cooper',
        },
        {
          value: 'COOPERCLUB',
          label: 'Cooper Clubman',
        },
        {
          value: 'COUNTRYMAN',
          label: 'Cooper Countryman',
        },
        {
          value: 'MINICOUPE',
          label: 'Cooper Coupe',
        },
        {
          value: 'MINIPACE',
          label: 'Cooper Paceman',
        },
        {
          value: 'COOPERROAD',
          label: 'Cooper Roadster',
        },
      ],
    },
    {
      make: {
        value: 'MIT',
        label: 'Mitsubishi',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: '3000GT',
          label: '3000GT',
        },
        {
          value: 'CORD',
          label: 'Cordia',
        },
        {
          value: 'DIAMAN',
          label: 'Diamante',
        },
        {
          value: 'ECLIP',
          label: 'Eclipse',
        },
        {
          value: 'MITECLCROS',
          label: 'Eclipse Cross',
        },
        {
          value: 'ENDEAVOR',
          label: 'Endeavor',
        },
        {
          value: 'MITEXP',
          label: 'Expo',
        },
        {
          value: 'GALANT',
          label: 'Galant',
        },
        {
          value: 'MITI',
          label: 'i',
        },
        {
          value: 'LANCERMITS',
          label: 'Lancer',
        },
        {
          value: 'LANCEREVO',
          label: 'Lancer Evolution',
        },
        {
          value: 'MITPU',
          label: 'Mighty Max',
        },
        {
          value: 'MIRAGE',
          label: 'Mirage',
        },
        {
          value: 'MITMIRG4',
          label: 'Mirage G4',
        },
        {
          value: 'MONT',
          label: 'Montero',
        },
        {
          value: 'MONTSPORT',
          label: 'Montero Sport',
        },
        {
          value: 'MITOTH',
          label: 'Other Mitsubishi Models',
        },
        {
          value: 'OUTLANDER',
          label: 'Outlander',
        },
        {
          value: 'OUTLANDSPT',
          label: 'Outlander Sport',
        },
        {
          value: 'PRECIS',
          label: 'Precis',
        },
        {
          value: 'RAIDERMITS',
          label: 'Raider',
        },
        {
          value: 'SIGMA',
          label: 'Sigma',
        },
        {
          value: 'MITSTAR',
          label: 'Starion',
        },
        {
          value: 'TRED',
          label: 'Tredia',
        },
        {
          value: 'MITVAN',
          label: 'Van',
        },
      ],
    },
    {
      make: {
        value: 'NISSAN',
        label: 'Nissan',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'NIS200SX',
          label: '200SX',
        },
        {
          value: '240SX',
          label: '240SX',
        },
        {
          value: '300ZXTURBO',
          label: '300ZX',
        },
        {
          value: '350Z',
          label: '350Z',
        },
        {
          value: '370Z',
          label: '370Z',
        },
        {
          value: 'ALTIMA',
          label: 'Altima',
        },
        {
          value: 'NISARIYA',
          label: 'Ariya',
        },
        {
          value: 'PATHARMADA',
          label: 'Armada',
        },
        {
          value: 'AXXESS',
          label: 'Axxess',
        },
        {
          value: 'CUBE',
          label: 'Cube',
        },
        {
          value: 'FRONTI',
          label: 'Frontier',
        },
        {
          value: 'GT-R',
          label: 'GT-R',
        },
        {
          value: 'JUKE',
          label: 'Juke',
        },
        {
          value: 'NISKICKS',
          label: 'Kicks',
        },
        {
          value: 'LEAF',
          label: 'Leaf',
        },
        {
          value: 'MAX',
          label: 'Maxima',
        },
        {
          value: 'MURANO',
          label: 'Murano',
        },
        {
          value: 'MURANOCROS',
          label: 'Murano CrossCabriolet',
        },
        {
          value: 'NV',
          label: 'NV',
        },
        {
          value: 'NISNV200',
          label: 'NV200',
        },
        {
          value: 'NX',
          label: 'NX',
        },
        {
          value: 'NISSOTH',
          label: 'Other Nissan Models',
        },
        {
          value: 'PATH',
          label: 'Pathfinder',
        },
        {
          value: 'NISPU',
          label: 'Pickup',
        },
        {
          value: 'PULSAR',
          label: 'Pulsar',
        },
        {
          value: 'QUEST',
          label: 'Quest',
        },
        {
          value: 'ROGUE',
          label: 'Rogue',
        },
        {
          value: 'NISROGSPT',
          label: 'Rogue Sport',
        },
        {
          value: 'SENTRA',
          label: 'Sentra',
        },
        {
          value: 'STANZA',
          label: 'Stanza',
        },
        {
          value: 'TITAN',
          label: 'Titan',
        },
        {
          value: 'NISVAN',
          label: 'Van',
        },
        {
          value: 'VERSA',
          label: 'Versa',
        },
        {
          value: 'NISVERSNOT',
          label: 'Versa Note',
        },
        {
          value: 'XTERRA',
          label: 'Xterra',
        },
        {
          value: 'NISSANZ',
          label: 'Z',
        },
      ],
    },
    {
      make: {
        value: 'OLDS',
        label: 'Oldsmobile',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: '88',
          label: '88',
        },
        {
          value: 'ACHIEV',
          label: 'Achieva',
        },
        {
          value: 'ALERO',
          label: 'Alero',
        },
        {
          value: 'AURORA',
          label: 'Aurora',
        },
        {
          value: 'BRAV',
          label: 'Bravada',
        },
        {
          value: 'CUCR',
          label: 'Custom Cruiser',
        },
        {
          value: 'OLDCUS',
          label: 'Cutlass',
        },
        {
          value: 'OLDCALAIS',
          label: 'Cutlass Calais',
        },
        {
          value: 'CIERA',
          label: 'Cutlass Ciera',
        },
        {
          value: 'CSUPR',
          label: 'Cutlass Supreme',
        },
        {
          value: 'OLDSFIR',
          label: 'Firenza',
        },
        {
          value: 'INTRIG',
          label: 'Intrigue',
        },
        {
          value: '98',
          label: 'Ninety-Eight',
        },
        {
          value: 'OMEG',
          label: 'Omega',
        },
        {
          value: 'OLDOTH',
          label: 'Other Oldsmobile Models',
        },
        {
          value: 'REGEN',
          label: 'Regency',
        },
        {
          value: 'SILHO',
          label: 'Silhouette',
        },
        {
          value: 'TORO',
          label: 'Toronado',
        },
      ],
    },
    {
      make: {
        value: 'PLYM',
        label: 'Plymouth',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ACC',
          label: 'Acclaim',
        },
        {
          value: 'ARROW',
          label: 'Arrow',
        },
        {
          value: 'BREEZE',
          label: 'Breeze',
        },
        {
          value: 'CARAVE',
          label: 'Caravelle',
        },
        {
          value: 'CHAMP',
          label: 'Champ',
        },
        {
          value: 'COLT',
          label: 'Colt',
        },
        {
          value: 'PLYMCONQ',
          label: 'Conquest',
        },
        {
          value: 'GRANFURY',
          label: 'Gran Fury',
        },
        {
          value: 'PLYMGRANV',
          label: 'Grand Voyager',
        },
        {
          value: 'HORI',
          label: 'Horizon',
        },
        {
          value: 'LASER',
          label: 'Laser',
        },
        {
          value: 'NEON',
          label: 'Neon',
        },
        {
          value: 'PLYOTH',
          label: 'Other Plymouth Models',
        },
        {
          value: 'PROWLE',
          label: 'Prowler',
        },
        {
          value: 'RELI',
          label: 'Reliant',
        },
        {
          value: 'SAPPOROPLY',
          label: 'Sapporo',
        },
        {
          value: 'SCAMP',
          label: 'Scamp',
        },
        {
          value: 'SUNDAN',
          label: 'Sundance',
        },
        {
          value: 'TRAILDUST',
          label: 'Trailduster',
        },
        {
          value: 'TURISMO',
          label: 'Turismo',
        },
        {
          value: 'VOYA',
          label: 'Voyager',
        },
      ],
    },
    {
      make: {
        value: 'POLESTAR',
        label: 'Polestar',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'POLESTAR1',
          label: 'Polestar 1',
        },
        {
          value: 'POLESTAR2',
          label: 'Polestar 2',
        },
      ],
    },
    {
      make: {
        value: 'PONT',
        label: 'Pontiac',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'T-1000',
          label: '1000',
        },
        {
          value: '6000',
          label: '6000',
        },
        {
          value: 'AZTEK',
          label: 'Aztek',
        },
        {
          value: 'BON',
          label: 'Bonneville',
        },
        {
          value: 'CATALINA',
          label: 'Catalina',
        },
        {
          value: 'FIERO',
          label: 'Fiero',
        },
        {
          value: 'FBIRD',
          label: 'Firebird',
        },
        {
          value: 'G3',
          label: 'G3',
        },
        {
          value: 'G5',
          label: 'G5',
        },
        {
          value: 'G6',
          label: 'G6',
        },
        {
          value: 'G8',
          label: 'G8',
        },
        {
          value: 'GRNDAM',
          label: 'Grand Am',
        },
        {
          value: 'GP',
          label: 'Grand Prix',
        },
        {
          value: 'GTO',
          label: 'GTO',
        },
        {
          value: 'J2000',
          label: 'J2000',
        },
        {
          value: 'LEMANS',
          label: 'Le Mans',
        },
        {
          value: 'MONTANA',
          label: 'Montana',
        },
        {
          value: 'PONOTH',
          label: 'Other Pontiac Models',
        },
        {
          value: 'PARISI',
          label: 'Parisienne',
        },
        {
          value: 'PHOENIX',
          label: 'Phoenix',
        },
        {
          value: 'SAFARIPONT',
          label: 'Safari',
        },
        {
          value: 'SOLSTICE',
          label: 'Solstice',
        },
        {
          value: 'SUNBIR',
          label: 'Sunbird',
        },
        {
          value: 'SUNFIR',
          label: 'Sunfire',
        },
        {
          value: 'TORRENT',
          label: 'Torrent',
        },
        {
          value: 'TS',
          label: 'Trans Sport',
        },
        {
          value: 'VIBE',
          label: 'Vibe',
        },
      ],
    },
    {
      make: {
        value: 'POR',
        label: 'Porsche',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'POR718BOX',
          label: '718 Boxster',
        },
        {
          value: 'POR718CAY',
          label: '718 Cayman',
        },
        {
          value: '911',
          label: '911',
        },
        {
          value: 'POR918SPYD',
          label: '918 Spyder',
        },
        {
          value: '924',
          label: '924',
        },
        {
          value: '928',
          label: '928',
        },
        {
          value: '944',
          label: '944',
        },
        {
          value: '968',
          label: '968',
        },
        {
          value: 'BOXSTE',
          label: 'Boxster',
        },
        {
          value: 'CARRERAGT',
          label: 'Carrera GT',
        },
        {
          value: 'CAYENNE',
          label: 'Cayenne',
        },
        {
          value: 'CAYMAN',
          label: 'Cayman',
        },
        {
          value: 'PORMACAN',
          label: 'Macan',
        },
        {
          value: 'POROTH',
          label: 'Other Porsche Models',
        },
        {
          value: 'PANAMERA',
          label: 'Panamera',
        },
        {
          value: 'PORTAYCAN',
          label: 'Taycan',
        },
      ],
    },
    {
      make: {
        value: 'RAM',
        label: 'RAM',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'RM1500',
          label: '1500',
        },
        {
          value: 'RM2500',
          label: '2500',
        },
        {
          value: 'RM3500',
          label: '3500',
        },
        {
          value: 'RM4500',
          label: '4500',
        },
        {
          value: 'RM5500',
          label: '5500',
        },
        {
          value: 'RMCV',
          label: 'C/V',
        },
        {
          value: 'RMPROMAST',
          label: 'ProMaster',
        },
        {
          value: 'RMPROCITY',
          label: 'ProMaster City',
        },
      ],
    },
    {
      make: {
        value: 'RIVIAN',
        label: 'Rivian',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'RIVIANR1S',
          label: 'R1S',
        },
        {
          value: 'RIVIANR1T',
          label: 'R1T',
        },
      ],
    },
    {
      make: {
        value: 'RR',
        label: 'Rolls-Royce',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'CAMAR',
          label: 'Camargue',
        },
        {
          value: 'CORN',
          label: 'Corniche',
        },
        {
          value: 'RRCULLINAN',
          label: 'Cullinan',
        },
        {
          value: 'RRDAWN',
          label: 'Dawn',
        },
        {
          value: 'GHOST',
          label: 'Ghost',
        },
        {
          value: 'RROTH',
          label: 'Other Rolls-Royce Models',
        },
        {
          value: 'PARKWARD',
          label: 'Park Ward',
        },
        {
          value: 'PHANT',
          label: 'Phantom',
        },
        {
          value: 'DAWN',
          label: 'Silver Dawn',
        },
        {
          value: 'SILSERAPH',
          label: 'Silver Seraph',
        },
        {
          value: 'RRSPIR',
          label: 'Silver Spirit',
        },
        {
          value: 'SPUR',
          label: 'Silver Spur',
        },
        {
          value: 'RRSPECTRE',
          label: 'Spectre',
        },
        {
          value: 'WRAI',
          label: 'Wraith',
        },
      ],
    },
    {
      make: {
        value: 'SAAB',
        label: 'Saab',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: '9-2X',
          label: '9-2X',
        },
        {
          value: '9-3',
          label: '9-3',
        },
        {
          value: '9-4X',
          label: '9-4X',
        },
        {
          value: '9-5',
          label: '9-5',
        },
        {
          value: '97X',
          label: '9-7X',
        },
        {
          value: '900',
          label: '900',
        },
        {
          value: '9000',
          label: '9000',
        },
        {
          value: 'SAOTH',
          label: 'Other Saab Models',
        },
      ],
    },
    {
      make: {
        value: 'SATURN',
        label: 'Saturn',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'ASTRA',
          label: 'Astra',
        },
        {
          value: 'AURA',
          label: 'Aura',
        },
        {
          value: 'ION',
          label: 'ION',
        },
        {
          value: 'SATLSE',
          label: 'L-Series',
        },
        {
          value: 'SATOTH',
          label: 'Other Saturn Models',
        },
        {
          value: 'OUTLOOK',
          label: 'Outlook',
        },
        {
          value: 'RELAY',
          label: 'Relay',
        },
        {
          value: 'SATSSE',
          label: 'S-Series',
        },
        {
          value: 'SKY',
          label: 'Sky',
        },
        {
          value: 'VUE',
          label: 'Vue',
        },
      ],
    },
    {
      make: {
        value: 'SCION',
        label: 'Scion',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'SCIFRS',
          label: 'FR-S',
        },
        {
          value: 'SCIIA',
          label: 'iA',
        },
        {
          value: 'SCIIM',
          label: 'iM',
        },
        {
          value: 'IQ',
          label: 'iQ',
        },
        {
          value: 'TC',
          label: 'tC',
        },
        {
          value: 'XA',
          label: 'xA',
        },
        {
          value: 'XB',
          label: 'xB',
        },
        {
          value: 'XD',
          label: 'xD',
        },
      ],
    },
    {
      make: {
        value: 'SMART',
        label: 'smart',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'FORTWO',
          label: 'fortwo',
        },
        {
          value: 'SMOTH',
          label: 'Other smart Models',
        },
      ],
    },
    {
      make: {
        value: 'SRT',
        label: 'SRT',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'SRTVIPER',
          label: 'Viper',
        },
      ],
    },
    {
      make: {
        value: 'SUB',
        label: 'Subaru',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'SUBASCENT',
          label: 'Ascent',
        },
        {
          value: 'BAJA',
          label: 'Baja',
        },
        {
          value: 'BRAT',
          label: 'Brat',
        },
        {
          value: 'SUBBRZ',
          label: 'BRZ',
        },
        {
          value: 'SUBCRSSTRK',
          label: 'Crosstrek',
        },
        {
          value: 'FOREST',
          label: 'Forester',
        },
        {
          value: 'IMPREZ',
          label: 'Impreza',
        },
        {
          value: 'IMPWRX',
          label: 'Impreza WRX',
        },
        {
          value: 'JUSTY',
          label: 'Justy',
        },
        {
          value: 'SUBL',
          label: 'L Series',
        },
        {
          value: 'LEGACY',
          label: 'Legacy',
        },
        {
          value: 'LOYALE',
          label: 'Loyale',
        },
        {
          value: 'SUBOTH',
          label: 'Other Subaru Models',
        },
        {
          value: 'SUBOUTBK',
          label: 'Outback',
        },
        {
          value: 'SUBSOLTERR',
          label: 'Solterra',
        },
        {
          value: 'SVX',
          label: 'SVX',
        },
        {
          value: 'B9TRIBECA',
          label: 'Tribeca',
        },
        {
          value: 'SUBWRX',
          label: 'WRX',
        },
        {
          value: 'XT',
          label: 'XT',
        },
        {
          value: 'XVCRSSTREK',
          label: 'XV Crosstrek',
        },
      ],
    },
    {
      make: {
        value: 'SUZUKI',
        label: 'Suzuki',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'AERIO',
          label: 'Aerio',
        },
        {
          value: 'EQUATOR',
          label: 'Equator',
        },
        {
          value: 'ESTEEM',
          label: 'Esteem',
        },
        {
          value: 'FORENZA',
          label: 'Forenza',
        },
        {
          value: 'GRANDV',
          label: 'Grand Vitara',
        },
        {
          value: 'KIZASHI',
          label: 'Kizashi',
        },
        {
          value: 'SUZOTH',
          label: 'Other Suzuki Models',
        },
        {
          value: 'RENO',
          label: 'Reno',
        },
        {
          value: 'SAMUR',
          label: 'Samurai',
        },
        {
          value: 'SIDE',
          label: 'Sidekick',
        },
        {
          value: 'SWIFT',
          label: 'Swift',
        },
        {
          value: 'SX4',
          label: 'SX4',
        },
        {
          value: 'VERONA',
          label: 'Verona',
        },
        {
          value: 'VITARA',
          label: 'Vitara',
        },
        {
          value: 'X90',
          label: 'X-90',
        },
        {
          value: 'XL7',
          label: 'XL7',
        },
      ],
    },
    {
      make: {
        value: 'TESLA',
        label: 'Tesla',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'TESCYBERTR',
          label: 'Cybertruck',
        },
        {
          value: 'TESMOD3',
          label: 'Model 3',
        },
        {
          value: 'TESMODS',
          label: 'Model S',
        },
        {
          value: 'TESMODX',
          label: 'Model X',
        },
        {
          value: 'TESMODY',
          label: 'Model Y',
        },
        {
          value: 'ROADSTER',
          label: 'Roadster',
        },
      ],
    },
    {
      make: {
        value: 'TOYOTA',
        label: 'Toyota',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: '4RUN',
          label: '4Runner',
        },
        {
          value: 'TOY86',
          label: '86',
        },
        {
          value: 'AVALON',
          label: 'Avalon',
        },
        {
          value: 'TOYBZ4X',
          label: 'bZ4X',
        },
        {
          value: 'TOYCHR',
          label: 'C-HR',
        },
        {
          value: 'CAMRY',
          label: 'Camry',
        },
        {
          value: 'CELICA',
          label: 'Celica',
        },
        {
          value: 'COROL',
          label: 'Corolla',
        },
        {
          value: 'TOYCORCROS',
          label: 'Corolla Cross',
        },
        {
          value: 'CORONA',
          label: 'Corona',
        },
        {
          value: 'CRESS',
          label: 'Cressida',
        },
        {
          value: 'TOYCROWN',
          label: 'Crown',
        },
        {
          value: 'ECHO',
          label: 'Echo',
        },
        {
          value: 'FJCRUIS',
          label: 'FJ Cruiser',
        },
        {
          value: 'TOYGR86',
          label: 'GR86',
        },
        {
          value: 'TOYGRDHIGH',
          label: 'Grand Highlander',
        },
        {
          value: 'HIGHLANDER',
          label: 'Highlander',
        },
        {
          value: 'LC',
          label: 'Land Cruiser',
        },
        {
          value: 'MATRIX',
          label: 'Matrix',
        },
        {
          value: 'TOYMIRAI',
          label: 'Mirai',
        },
        {
          value: 'MR2',
          label: 'MR2',
        },
        {
          value: 'MR2SPYDR',
          label: 'MR2 Spyder',
        },
        {
          value: 'TOYOTH',
          label: 'Other Toyota Models',
        },
        {
          value: 'PASEO',
          label: 'Paseo',
        },
        {
          value: 'PICKUP',
          label: 'Pickup',
        },
        {
          value: 'PREVIA',
          label: 'Previa',
        },
        {
          value: 'PRIUS',
          label: 'Prius',
        },
        {
          value: 'PRIUSC',
          label: 'Prius C',
        },
        {
          value: 'TOYPRIPRM',
          label: 'Prius Prime',
        },
        {
          value: 'PRIUSV',
          label: 'Prius V',
        },
        {
          value: 'RAV4',
          label: 'RAV4',
        },
        {
          value: 'SEQUOIA',
          label: 'Sequoia',
        },
        {
          value: 'SIENNA',
          label: 'Sienna',
        },
        {
          value: 'SOLARA',
          label: 'Solara',
        },
        {
          value: 'STARLET',
          label: 'Starlet',
        },
        {
          value: 'SUPRA',
          label: 'Supra',
        },
        {
          value: 'T100',
          label: 'T100',
        },
        {
          value: 'TACOMA',
          label: 'Tacoma',
        },
        {
          value: 'TERCEL',
          label: 'Tercel',
        },
        {
          value: 'TUNDRA',
          label: 'Tundra',
        },
        {
          value: 'TOYVAN',
          label: 'Van',
        },
        {
          value: 'VENZA',
          label: 'Venza',
        },
        {
          value: 'YARIS',
          label: 'Yaris',
        },
      ],
    },
    {
      make: {
        value: 'VINFAST',
        label: 'VinFast',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'VINFVF8',
          label: 'VF 8',
        },
      ],
    },
    {
      make: {
        value: 'VOLKS',
        label: 'Volkswagen',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'VOLKSARTE',
          label: 'Arteon',
        },
        {
          value: 'VOLKSATL',
          label: 'Atlas',
        },
        {
          value: 'BEETLE',
          label: 'Beetle',
        },
        {
          value: 'VOLKSCAB',
          label: 'Cabrio',
        },
        {
          value: 'CAB',
          label: 'Cabriolet',
        },
        {
          value: 'CC',
          label: 'CC',
        },
        {
          value: 'CORR',
          label: 'Corrado',
        },
        {
          value: 'DASHER',
          label: 'Dasher',
        },
        {
          value: 'VOLKSEGOLF',
          label: 'e-Golf',
        },
        {
          value: 'EOS',
          label: 'Eos',
        },
        {
          value: 'EUROVAN',
          label: 'Eurovan',
        },
        {
          value: 'VOLKSFOX',
          label: 'Fox',
        },
        {
          value: 'GOLF',
          label: 'Golf',
        },
        {
          value: 'GOLFR',
          label: 'Golf R',
        },
        {
          value: 'GTI',
          label: 'GTI',
        },
        {
          value: 'VOLKSID4',
          label: 'ID.4',
        },
        {
          value: 'JET',
          label: 'Jetta',
        },
        {
          value: 'VWOTH',
          label: 'Other Volkswagen Models',
        },
        {
          value: 'PASS',
          label: 'Passat',
        },
        {
          value: 'PHAETON',
          label: 'Phaeton',
        },
        {
          value: 'RABBITPU',
          label: 'Pickup',
        },
        {
          value: 'QUAN',
          label: 'Quantum',
        },
        {
          value: 'R32',
          label: 'R32',
        },
        {
          value: 'RABBIT',
          label: 'Rabbit',
        },
        {
          value: 'ROUTAN',
          label: 'Routan',
        },
        {
          value: 'SCIR',
          label: 'Scirocco',
        },
        {
          value: 'VOLKSTAOS',
          label: 'Taos',
        },
        {
          value: 'TIGUAN',
          label: 'Tiguan',
        },
        {
          value: 'TOUAREG',
          label: 'Touareg',
        },
        {
          value: 'VANAG',
          label: 'Vanagon',
        },
      ],
    },
    {
      make: {
        value: 'VOLVO',
        label: 'Volvo',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: '240',
          label: '240',
        },
        {
          value: '260',
          label: '260',
        },
        {
          value: '740',
          label: '740',
        },
        {
          value: '760',
          label: '760',
        },
        {
          value: '780',
          label: '780',
        },
        {
          value: '850',
          label: '850',
        },
        {
          value: '940',
          label: '940',
        },
        {
          value: '960',
          label: '960',
        },
        {
          value: 'C30',
          label: 'C30',
        },
        {
          value: 'VOLVOC40',
          label: 'C40',
        },
        {
          value: 'C70',
          label: 'C70',
        },
        {
          value: 'VOLOTH',
          label: 'Other Volvo Models',
        },
        {
          value: 'S40',
          label: 'S40',
        },
        {
          value: 'S60',
          label: 'S60',
        },
        {
          value: 'S70',
          label: 'S70',
        },
        {
          value: 'S80',
          label: 'S80',
        },
        {
          value: 'S90',
          label: 'S90',
        },
        {
          value: 'V40',
          label: 'V40',
        },
        {
          value: 'V50',
          label: 'V50',
        },
        {
          value: 'VOLVOV60',
          label: 'V60',
        },
        {
          value: 'V70',
          label: 'V70',
        },
        {
          value: 'V90',
          label: 'V90',
        },
        {
          value: 'VOLVOXC40',
          label: 'XC40',
        },
        {
          value: 'XC60',
          label: 'XC60',
        },
        {
          value: 'XC',
          label: 'XC70',
        },
        {
          value: 'XC90',
          label: 'XC90',
        },
      ],
    },
    {
      make: {
        value: 'YUGO',
        label: 'Yugo',
      },
      models: [
        {
          value: '',
          label: 'Any Model',
        },
        {
          value: 'GV',
          label: 'GV',
        },
        {
          value: 'GVL',
          label: 'GVL',
        },
        {
          value: 'GVX',
          label: 'GVX',
        },
        {
          value: 'YUOTH',
          label: 'Other Yugo Models',
        },
      ],
    },
  ],
};
